function Terms() {
  return (
    <main className="h-svh overflow-y-scroll">
      <div className="mx-auto max-w-screen-lg px-4 py-4 md:px-8 md:py-8">
        <h1 className="text-center text-lg font-bold">
          Termos e condição de uso
        </h1>
        <p className="mt-6 text-base">
          <strong>1. APRESENTAÇÃO E OBJETO</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          A presente Pol&iacute;tica de Uso tem por objeto estabelecer as
          diretrizes, condi&ccedil;&otilde;es, direitos e deveres relacionados
          &agrave; utiliza&ccedil;&atilde;o da&nbsp;
          <strong>Plataforma Digital GPMED,</strong>
          &nbsp;de titularidade e responsabilidade da&nbsp;
          <strong>GPMED LTDA</strong>, pessoa jur&iacute;dica brasileira,
          regularmente constitu&iacute;da, com atua&ccedil;&atilde;o voltada
          &agrave; oferta de conte&uacute;do t&eacute;cnico, cient&iacute;fico e
          informativo&nbsp;
          <strong>
            exclusivamente direcionado a profissionais da &aacute;rea da
            sa&uacute;de
          </strong>
          , especialmente m&eacute;dicos, estudantes de medicina e residentes.
        </p>
        <p className="mt-3 text-justify text-sm">
          A Plataforma Digital GPMED constitui uma extens&atilde;o dos
          servi&ccedil;os educacionais ofertados pela GPMED LTDA, sendo
          considerada uma solu&ccedil;&atilde;o tecnol&oacute;gica de apoio
          &agrave; forma&ccedil;&atilde;o, atualiza&ccedil;&atilde;o e
          desenvolvimento profissional de m&eacute;dicos e estudantes, por meio
          de conte&uacute;dos organizados, estruturados e apresentados de forma
          did&aacute;tica.
        </p>
        <p className="mt-3 text-justify text-sm">
          A solu&ccedil;&atilde;o &eacute; caracterizada como um infoproduto
          digital, baseado em curadoria de conte&uacute;do, pesquisa
          cient&iacute;fica e pr&aacute;ticas educacionais modernas, e tem como
          miss&atilde;o fortalecer o conhecimento cl&iacute;nico,
          terap&ecirc;utico e assistencial dos seus usu&aacute;rios.
        </p>
        <p className="mt-3 text-justify text-sm">
          A utiliza&ccedil;&atilde;o da plataforma implica a ades&atilde;o
          volunt&aacute;ria e consciente &agrave;s regras aqui estabelecidas, as
          quais visam assegurar a transpar&ecirc;ncia, a seguran&ccedil;a da
          informa&ccedil;&atilde;o, a prote&ccedil;&atilde;o de dados pessoais e
          a conformidade com a legisla&ccedil;&atilde;o brasileira vigente.
          Nesse sentido, todas as pr&aacute;ticas desenvolvidas no &acirc;mbito
          da plataforma est&atilde;o amparadas pela:
        </p>

        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Lei Geral de Prote&ccedil;&atilde;o de Dados Pessoais (Lei n&ordm;
            13.709/2018 &ndash; LGPD)
          </strong>
          , que disciplina o tratamento de dados pessoais com o objetivo de
          proteger os direitos fundamentais de liberdade e privacidade;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Marco Civil da Internet (Lei n&ordm; 12.965/2014)</strong>,
          que estabelece os princ&iacute;pios, garantias, direitos e deveres
          para o uso da internet no Brasil, assegurando o sigilo, a
          prote&ccedil;&atilde;o dos dados pessoais e a
          preserva&ccedil;&atilde;o da privacidade do usu&aacute;rio;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            C&oacute;digo de Defesa do Consumidor (Lei n&ordm; 8.078/1990)
          </strong>
          , aplic&aacute;vel &agrave; rela&ccedil;&atilde;o de consumo
          estabelecida com os usu&aacute;rios, que assegura o direito &agrave;
          informa&ccedil;&atilde;o clara, adequada e &agrave;
          prote&ccedil;&atilde;o contra pr&aacute;ticas abusivas.
        </p>
        <p className="mt-3 text-justify text-sm">
          O escopo de funcionalidades oferecido pela Plataforma Digital GPMED
          contempla, mas n&atilde;o se limita &agrave;s seguintes
          opera&ccedil;&otilde;es:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Acesso aos conte&uacute;dos educativos exclusivos, organizados por
          &aacute;reas m&eacute;dicas e categorias de especialidade;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Consulta de materiais t&eacute;cnicos sobre terap&ecirc;uticas,
          condutas cl&iacute;nicas e farmacologia aplicada;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Organiza&ccedil;&atilde;o de conte&uacute;dos por n&iacute;vel de
          forma&ccedil;&atilde;o (acad&ecirc;mico, residente, profissional
          atuante);
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Assinatura de planos personalizados conforme o perfil profissional do
          usu&aacute;rio;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Recebimento de notifica&ccedil;&otilde;es, atualiza&ccedil;&otilde;es
          de conte&uacute;do e funcionalidades de interesse;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Canal de comunica&ccedil;&atilde;o institucional entre a empresa e o
          usu&aacute;rio, com suporte t&eacute;cnico e atendimento;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Recursos de autentica&ccedil;&atilde;o e seguran&ccedil;a que garantem
          o acesso restrito, seguro e individualizado;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Gest&atilde;o de dados cadastrais e de pagamento diretamente na
          interface da plataforma;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Solicita&ccedil;&atilde;o de valida&ccedil;&atilde;o documental,
          quando necess&aacute;ria para acesso a categorias de planos
          diferenciados.
        </p>
        <p className="mt-3 text-justify text-sm">
          A GPMED LTDA declara expressamente que&nbsp;
          <strong>
            n&atilde;o realiza qualquer atividade de telemedicina, consulta
            m&eacute;dica ou prescri&ccedil;&atilde;o cl&iacute;nica direta
          </strong>
          , sendo sua atua&ccedil;&atilde;o restrita &agrave;&nbsp;
          <strong>
            dissemina&ccedil;&atilde;o de conte&uacute;do educacional
          </strong>
          , sem finalidade diagn&oacute;stica, terap&ecirc;utica ou assistencial
          direta ao paciente, de modo a n&atilde;o se confundir com qualquer
          servi&ccedil;o m&eacute;dico-hospitalar.
        </p>
        <p className="mt-3 text-justify text-sm">
          A&nbsp;
          <strong>
            GPMED LTDA declara expressamente que sua plataforma digital
            n&atilde;o substitui, em nenhuma hip&oacute;tese, a conduta
            m&eacute;dica
          </strong>
          . N&atilde;o realiza qualquer atividade de telemedicina, consulta
          m&eacute;dica ou prescri&ccedil;&atilde;o cl&iacute;nica direta, sendo
          sua atua&ccedil;&atilde;o estritamente restrita &agrave;
          dissemina&ccedil;&atilde;o de conte&uacute;do educacional,&nbsp;
          <strong>
            sem finalidade diagn&oacute;stica, terap&ecirc;utica ou assistencial
            direta ao paciente
          </strong>
          , de modo a n&atilde;o se confundir com qualquer servi&ccedil;o
          m&eacute;dico-hospitalar.
        </p>
        <p className="mt-3 text-justify text-sm">
          O presente instrumento busca proporcionar ao usu&aacute;rio total
          clareza sobre a natureza do servi&ccedil;o prestado, promovendo a
          conformidade legal, a prote&ccedil;&atilde;o de direitos fundamentais
          e a valoriza&ccedil;&atilde;o da rela&ccedil;&atilde;o &eacute;tica
          entre empresa, conte&uacute;do e usu&aacute;rio.
        </p>

        <p className="mt-6 text-base">
          <strong>2. CONDIÇÕES GERAIS DE USO</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          O acesso e a utiliza&ccedil;&atilde;o da&nbsp;
          <strong>Plataforma Digital GPMED </strong>
          est&atilde;o expressamente condicionados &agrave; leitura,
          compreens&atilde;o e integral&nbsp;
          <strong>
            aceita&ccedil;&atilde;o, de forma livre, informada e
            inequ&iacute;voca
          </strong>
          , de todos os termos, cl&aacute;usulas, regras e
          condi&ccedil;&otilde;es estabelecidas neste instrumento, que se
          constitui como o&nbsp;
          <strong>contrato eletr&ocirc;nico de ades&atilde;o</strong>
          &nbsp;celebrado entre o&nbsp;
          <strong>usu&aacute;rio</strong>
          &nbsp;e a&nbsp;
          <strong>empresa GPMED LTDA</strong>, titular e respons&aacute;vel
          legal pela solu&ccedil;&atilde;o tecnol&oacute;gica.
        </p>
        <p className="mt-3 text-justify text-sm">
          Este contrato rege a rela&ccedil;&atilde;o jur&iacute;dica decorrente
          da utiliza&ccedil;&atilde;o dos recursos e funcionalidades
          disponibilizados na Plataforma Digital GPMED , com fundamento nos
          princ&iacute;pios da&nbsp;
          <strong>
            legalidade, transpar&ecirc;ncia, finalidade, livre acesso,
            responsabilidade, seguran&ccedil;a, n&atilde;o
            discrimina&ccedil;&atilde;o, presta&ccedil;&atilde;o de contas e
            boa-f&eacute;
          </strong>
          , conforme disposto na&nbsp;
          <strong>
            Lei Geral de Prote&ccedil;&atilde;o de Dados Pessoais (LGPD &ndash;
            Lei n&ordm; 13.709/2018, art. 6&ordm;)
          </strong>
          , assegurando que o tratamento de dados pessoais e a
          utiliza&ccedil;&atilde;o da plataforma digital ocorram de forma
          l&iacute;cita, &eacute;tica, proporcional e compat&iacute;vel com os
          direitos fundamentais dos titulares.
        </p>
        <p className="mt-3 text-justify text-sm">
          De igual modo, este instrumento &eacute; amparado pelas diretrizes
          do&nbsp;
          <strong>Marco Civil da Internet (Lei n&ordm; 12.965/2014)</strong>,
          que imp&otilde;e aos provedores de aplica&ccedil;&otilde;es de
          internet &ndash; como a presente Plataforma Digital GPMED &ndash; a
          obriga&ccedil;&atilde;o de garantir a&nbsp;
          <strong>
            prote&ccedil;&atilde;o &agrave; privacidade, &agrave;
            inviolabilidade das comunica&ccedil;&otilde;es, &agrave; guarda
            segura de dados pessoais e ao fornecimento de
            informa&ccedil;&otilde;es claras sobre suas pr&aacute;ticas de
            tratamento de dados
          </strong>
          , nos termos do artigo 7&ordm; da referida legisla&ccedil;&atilde;o.
        </p>
        <p className="mt-3 text-justify text-sm">
          Ainda, aplica-se subsidiariamente o&nbsp;
          <strong>
            C&oacute;digo de Defesa do Consumidor (Lei n&ordm; 8.078/1990)
          </strong>
          , especialmente no que se refere ao direito &agrave;
          informa&ccedil;&atilde;o adequada, &agrave; prote&ccedil;&atilde;o
          contratual, &agrave; preven&ccedil;&atilde;o de riscos e &agrave;
          responsabiliza&ccedil;&atilde;o por eventuais falhas nos
          servi&ccedil;os prestados digitalmente.
        </p>
        <p className="mt-3 text-justify text-sm">
          Assim, a utiliza&ccedil;&atilde;o da Plataforma Digital GPMED
          pressup&otilde;e a ades&atilde;o consciente &agrave;s normas aqui
          descritas e representa o compromisso do usu&aacute;rio com a&nbsp;
          <strong>
            &eacute;tica digital, a veracidade dos dados fornecidos e a
            observ&acirc;ncia &agrave;s regras de conduta
          </strong>
          &nbsp;que regem o ambiente virtual, sendo responsabilidade da empresa
          assegurar que a experi&ecirc;ncia do usu&aacute;rio seja segura,
          educativa, transparente e respeitosa de seus direitos legais,
          contratuais e personal&iacute;ssimos.
        </p>
        <p className="mt-3 text-justify text-sm">
          <strong>
            2.1 Requisitos legais e t&eacute;cnicos para
            utiliza&ccedil;&atilde;o da Plataforma Digital GPMED&nbsp;
          </strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          O acesso e uso das funcionalidades da&nbsp;
          <strong>Plataforma Digital GPMED </strong>
          &eacute; de uso exclusivo por profissionais da sa&uacute;de e
          estudantes regularmente matriculados em institui&ccedil;&otilde;es
          reconhecidas, sendo vedado o uso por pessoas n&atilde;o habilitadas ou
          leiga condicionados ao atendimento de requisitos legais,
          t&eacute;cnicos e comportamentais essenciais &agrave;
          preserva&ccedil;&atilde;o da seguran&ccedil;a jur&iacute;dica,
          funcionalidade da aplica&ccedil;&atilde;o e &agrave;
          prote&ccedil;&atilde;o de todos os envolvidos na rela&ccedil;&atilde;o
          de consumo e uso da tecnologia. Tais requisitos s&atilde;o
          indispens&aacute;veis para garantir o correto enquadramento do
          usu&aacute;rio no perfil-alvo da solu&ccedil;&atilde;o, bem como para
          assegurar o uso respons&aacute;vel da plataforma conforme os preceitos
          do ordenamento jur&iacute;dico brasileiro.
        </p>
        <p className="mt-3 text-justify text-sm">
          Dessa forma, para que um indiv&iacute;duo possa realizar o cadastro,
          acessar e utilizar regularmente os servi&ccedil;os do Plataforma
          Digital GPMED, &eacute; necess&aacute;rio que preencha cumulativamente
          os seguintes crit&eacute;rios:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Possuir idade m&iacute;nima de 18 (dezoito) anos completos
          </strong>
          , no momento do aceite dos Termos de Uso e Pol&iacute;tica de
          Privacidade, conforme exigido pela legisla&ccedil;&atilde;o civil
          brasileira para celebra&ccedil;&atilde;o de contratos por pessoas
          plenamente capazes (artigos 5&ordm; e 6&ordm; do&nbsp;
          <strong>C&oacute;digo Civil Brasileiro</strong>
          );
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Estar em pleno gozo da capacidade civil</strong>, n&atilde;o
          se encontrando em nenhuma das hip&oacute;teses de incapacidade
          absoluta ou relativa previstas no artigo 3&ordm; do C&oacute;digo
          Civil, exceto se legalmente representado ou assistido, conforme o
          caso;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Utilizar dispositivo compat&iacute;vel com os sistemas operacionais
            suportados pelo aplicativo
          </strong>
          , como Android ou iOS, devendo os mesmos estar atualizados de acordo
          com os requisitos t&eacute;cnicos m&iacute;nimos exigidos para o bom
          funcionamento da aplica&ccedil;&atilde;o;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Possuir conex&atilde;o ativa &agrave; internet</strong>,
          adequada ao carregamento dos conte&uacute;dos digitais e das
          funcionalidades oferecidas pela Plataforma, cuja disponibilidade
          &eacute; essencial &agrave; presta&ccedil;&atilde;o cont&iacute;nua e
          eficaz dos servi&ccedil;os educacionais;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Fornecer, no momento do cadastro, informa&ccedil;&otilde;es pessoais
            verdadeiras, completas, atualizadas e compat&iacute;veis com a
            finalidade da Plataforma
          </strong>
          , assumindo total responsabilidade pela veracidade, autenticidade e
          integridade dos dados cadastrados, nos termos do artigo 6&ordm;,
          inciso V da&nbsp;
          <strong>
            Lei Geral de Prote&ccedil;&atilde;o de Dados Pessoais (LGPD &ndash;
            Lei n&ordm; 13.709/2018)
          </strong>
          .
        </p>
        <p className="mt-3 text-justify text-sm">
          Em conson&acirc;ncia com o princ&iacute;pio da&nbsp;
          <strong>necessidade</strong>
          &nbsp;e da&nbsp;
          <strong>adequa&ccedil;&atilde;o</strong>
          &nbsp;previstos na LGPD, e visando assegurar a correta
          categoriza&ccedil;&atilde;o dos usu&aacute;rios quanto aos&nbsp;
          <strong>planos de assinatura oferecidos</strong>, a GPMED LTDA
          reserva-se o direito de, a seu exclusivo crit&eacute;rio, solicitar
          documenta&ccedil;&atilde;o complementar para&nbsp;
          <strong>
            validar a condi&ccedil;&atilde;o profissional do usu&aacute;rio
          </strong>
          , especialmente nos casos em que o acesso ao conte&uacute;do ou aos
          valores dos planos estiver vinculado &agrave;
          comprova&ccedil;&atilde;o de v&iacute;nculo com
          institui&ccedil;&atilde;o de ensino ou atua&ccedil;&atilde;o na
          &aacute;rea da sa&uacute;de. Tal verifica&ccedil;&atilde;o
          poder&aacute; ser realizada por meio de documentos como comprovante de
          matr&iacute;cula, carteira de estudante, registro profissional (CRM),
          entre outros.
        </p>
        <p className="mt-3 text-justify text-sm">
          Caso haja d&uacute;vida razo&aacute;vel quanto &agrave; veracidade ou
          integridade da documenta&ccedil;&atilde;o apresentada, a GPMED LTDA
          poder&aacute; entrar em contato com o emissor do referido documento
          para confirma&ccedil;&atilde;o, em conformidade com o artigo 7&ordm;,
          inciso II da LGPD, que autoriza o tratamento de dados pessoais para
          o&nbsp;
          <strong>
            cumprimento de obriga&ccedil;&atilde;o legal ou regulat&oacute;ria e
            para o exerc&iacute;cio regular de direitos
          </strong>
          &nbsp;em processos administrativos ou contratuais.
        </p>
        <p className="mt-3 text-justify text-sm">
          A n&atilde;o observ&acirc;ncia dos requisitos aqui estabelecidos
          poder&aacute; implicar a&nbsp;
          <strong>
            suspens&atilde;o ou exclus&atilde;o da conta do usu&aacute;rio
          </strong>
          , sem preju&iacute;zo da responsabiliza&ccedil;&atilde;o civil, penal
          e administrativa, conforme aplic&aacute;vel, inclusive por eventuais
          preju&iacute;zos causados &agrave; GPMED LTDA ou a terceiros.
        </p>

        <p className="mt-3 text-justify text-sm">
          <strong>2.2 Responsabilidades do Usu&aacute;rio</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          Ao proceder com o cadastro, acesso e utiliza&ccedil;&atilde;o da&nbsp;
          <strong>Plataforma Digital GPMED,</strong>
          &nbsp;o usu&aacute;rio &eacute; integralmente respons&aacute;vel por
          todas as a&ccedil;&otilde;es realizadas sob sua conta, mesmo que por
          terceiros que tenham tido acesso &agrave;s suas credenciais por
          neglig&ecirc;ncia, compartilhamento volunt&aacute;rio ou qualquer
          outro meio. Responder&aacute;&nbsp;
          <strong>solidariamente</strong>
          &nbsp;pelos danos causados &agrave; GPMED LTDA ou a terceiros em
          decorr&ecirc;ncia de tais acessos indevidos.
        </p>
        <p className="mt-3 text-justify text-sm">
          Nesse contexto, s&atilde;o deveres do usu&aacute;rio, sem
          preju&iacute;zo de outras disposi&ccedil;&otilde;es previstas neste
          instrumento ou na legisla&ccedil;&atilde;o vigente:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Responsabilidade individual pelo uso da conta de acesso:
          </strong>
          &nbsp;o usu&aacute;rio compromete-se a manter o sigilo de suas
          credenciais (login e senha), responsabilizando-se integralmente por
          quaisquer acessos ou opera&ccedil;&otilde;es realizadas por meio de
          sua conta, ainda que por terceiros. O compartilhamento indevido de
          credenciais configura viola&ccedil;&atilde;o contratual, podendo
          implicar em san&ccedil;&otilde;es administrativas, civis e, se for o
          caso, penais.
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Uso da Plataforma para finalidades l&iacute;citas e
            compat&iacute;veis com sua proposta:
          </strong>
          &nbsp;a Plataforma Digital GPMED deve ser utilizada exclusivamente
          para fins&nbsp;
          <strong>pessoais, educacionais e informativos</strong>, em
          conformidade com sua natureza institucional e pedag&oacute;gica.
          &Eacute; vedado ao usu&aacute;rio empregar a Plataforma Digital GPMED
          para&nbsp;
          <strong>
            fins comerciais, promocionais, publicit&aacute;rios, fraudulentos,
            il&iacute;citos, abusivos ou que causem preju&iacute;zo &agrave;
            GPMED LTDA, a terceiros ou ao ordenamento jur&iacute;dico nacional
          </strong>
          .
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Respeito &agrave; legisla&ccedil;&atilde;o vigente:</strong>o
          usu&aacute;rio reconhece que responder&aacute;, nas esferas
          <strong>civil, penal e administrativa</strong>, por qualquer
          utiliza&ccedil;&atilde;o indevida do Plataforma Digital GPMED,
          incluindo, mas n&atilde;o se limitando a: viola&ccedil;&atilde;o de
          <strong>direitos autorais</strong>,
          <strong>propriedade intelectual</strong>,
          <strong>segredos comerciais</strong>,
          <strong>direitos da personalidade</strong>,
          <strong>dados pessoais de terceiros</strong>, ou qualquer conduta que
          infrinja dispositivos da
          <strong>LGPD</strong>, do
          <strong>Marco Civil da Internet</strong>, do
          <strong>C&oacute;digo Civil</strong>, do
          <strong>C&oacute;digo Penal</strong>
          ou de legisla&ccedil;&atilde;o especial.
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Veracidade e atualiza&ccedil;&atilde;o das informa&ccedil;&otilde;es
            cadastrais:
          </strong>
          &nbsp;&eacute; dever do usu&aacute;rio fornecer dados pessoais
          verdadeiros, completos e atualizados, sob pena de
          responsabiliza&ccedil;&atilde;o por eventuais consequ&ecirc;ncias
          decorrentes de informa&ccedil;&otilde;es falsas ou desatualizadas.
          Caso identifique qualquer uso n&atilde;o autorizado de sua conta ou
          suspeita de comprometimento de suas informa&ccedil;&otilde;es, o
          usu&aacute;rio dever&aacute; comunicar imediatamente a GPMED LTDA por
          meio dos canais oficiais de atendimento.
        </p>
        <p className="mt-3 text-justify text-sm">
          O descumprimento de quaisquer das responsabilidades aqui previstas
          poder&aacute; ensejar, a exclusivo crit&eacute;rio da GPMED
          LTDA,&nbsp;
          <strong>
            a suspens&atilde;o tempor&aacute;ria ou exclus&atilde;o definitiva
            da conta do usu&aacute;rio
          </strong>
          , sem preju&iacute;zo das medidas legais cab&iacute;veis para
          ressarcimento de danos e prote&ccedil;&atilde;o da integridade da
          plataforma e de seus demais usu&aacute;rios.
        </p>
        <p className="mt-3 text-justify text-sm">
          <strong>2.3 Responsabilidades da GPMED LTDA</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          A&nbsp;
          <strong>GPMED Plataforma Digital</strong>, na qualidade de&nbsp;
          <strong>controladora de dados pessoais</strong>
          &nbsp;e fornecedora da solu&ccedil;&atilde;o tecnol&oacute;gica
          representada pelo Plataforma Digital GPMED, assume o compromisso
          institucional, &eacute;tico e legal de assegurar a&nbsp;
          <strong>
            confiabilidade, integridade e seguran&ccedil;a dos servi&ccedil;os
            prestados
          </strong>
          , bem como o&nbsp;
          <strong>
            respeito aos direitos fundamentais dos usu&aacute;rios
          </strong>
          .
        </p>
        <p className="mt-3 text-justify text-sm">
          Nesse sentido, a GPMED LTDA se compromete a:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Garantir a disponibilidade e funcionalidade do Plataforma Digital
            GPMED:
          </strong>
          &nbsp;manter a opera&ccedil;&atilde;o da plataforma de forma
          cont&iacute;nua, est&aacute;vel e segura, disponibilizando seus
          conte&uacute;dos e funcionalidades de maneira eficaz, ressalvadas
          eventuais interrup&ccedil;&otilde;es motivadas por&nbsp;
          <strong>
            manuten&ccedil;&atilde;o preventiva, atualiza&ccedil;&atilde;o
            tecnol&oacute;gica, falhas t&eacute;cnicas fora do controle da
            empresa ou hip&oacute;teses de for&ccedil;a maior e caso fortuito
          </strong>
          , nos termos do artigo 393 do C&oacute;digo Civil Brasileiro;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Assegurar a prote&ccedil;&atilde;o de dados pessoais:</strong>
          &nbsp;observar rigorosamente os princ&iacute;pios, direitos e deveres
          estabelecidos na&nbsp;
          <strong>
            Lei n&ordm; 13.709/2018 &ndash; Lei Geral de Prote&ccedil;&atilde;o
            de Dados Pessoais (LGPD)
          </strong>
          , adotando&nbsp;
          <strong>
            medidas t&eacute;cnicas e administrativas adequadas para proteger os
            dados pessoais dos usu&aacute;rios contra acessos n&atilde;o
            autorizados, incidentes de seguran&ccedil;a, vazamentos,
            destrui&ccedil;&atilde;o, perda, altera&ccedil;&atilde;o ou qualquer
            forma de tratamento inadequado ou il&iacute;cito
          </strong>
          , conforme previsto no artigo 46 da LGPD;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Tratar os dados pessoais com finalidade leg&iacute;tima e
            consentida:
          </strong>
          &nbsp;comprometer-se a utilizar os dados coletados&nbsp;
          <strong>
            &uacute;nica e exclusivamente para as finalidades informadas e
            consentidas pelos titulares
          </strong>
          , abstendo-se de realizar qualquer uso com prop&oacute;sito&nbsp;
          <strong>
            publicit&aacute;rio, promocional ou de marketing direto
          </strong>
          , salvo se houver&nbsp;
          <strong>
            consentimento pr&eacute;vio, livre, informado e inequ&iacute;voco do
            titular dos dados
          </strong>
          , nos termos do artigo 7&ordm;, inciso I, da LGPD;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Manter canais de atendimento acess&iacute;veis e eficazes:
          </strong>
          &nbsp;disponibilizar canais oficiais de suporte e
          comunica&ccedil;&atilde;o com os usu&aacute;rios, por meio dos quais
          ser&aacute; poss&iacute;vel encaminhar&nbsp;
          <strong>
            d&uacute;vidas, sugest&otilde;es, reclama&ccedil;&otilde;es,
            solicita&ccedil;&otilde;es de informa&ccedil;&otilde;es e
            exerc&iacute;cio dos direitos assegurados aos titulares de dados
            pessoais
          </strong>
          , conforme os artigos 18 a 20 da LGPD e os princ&iacute;pios da
          boa-f&eacute; e transpar&ecirc;ncia previstos no C&oacute;digo de
          Defesa do Consumidor (Lei n&ordm; 8.078/1990);
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Promover o constante aprimoramento de sua governan&ccedil;a em
            privacidade e seguran&ccedil;a da informa&ccedil;&atilde;o:
          </strong>
          &nbsp;revisar e atualizar periodicamente suas pol&iacute;ticas
          internas, mecanismos de controle, contratos com operadores e
          treinamentos de equipe, com vistas &agrave;&nbsp;
          <strong>
            manuten&ccedil;&atilde;o da conformidade legal e &agrave;
            valoriza&ccedil;&atilde;o dos direitos dos titulares de dados
            pessoais
          </strong>
          .
        </p>
        <p className="mt-3 text-justify text-sm">
          A GPMED LTDA reafirma seu compromisso com a&nbsp;
          <strong>
            &eacute;tica digital, a responsabilidade social e a conformidade
            normativa
          </strong>
          , zelando pela entrega de um servi&ccedil;o educacional de
          excel&ecirc;ncia, acess&iacute;vel, seguro e respeitoso com os
          princ&iacute;pios que regem o ordenamento jur&iacute;dico brasileiro.
        </p>
        <p className="mt-3 text-justify text-sm">
          <strong>2.4 Regras de Conduta e Uso Aceit&aacute;vel</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          Ao aceitar integralmente os termos desta Pol&iacute;tica de Uso,
          o&nbsp;
          <strong>
            usu&aacute;rio declara estar ciente de que sua perman&ecirc;ncia e
            utiliza&ccedil;&atilde;o da Plataforma Digital GPMED est&atilde;o
            condicionadas &agrave; ado&ccedil;&atilde;o de conduta &eacute;tica,
            respons&aacute;vel, diligente e compat&iacute;vel com os
            princ&iacute;pios que regem a legisla&ccedil;&atilde;o brasileira
            vigente
          </strong>
          , em especial as normas relativas &agrave; prote&ccedil;&atilde;o de
          dados pessoais, &agrave; boa-f&eacute; contratual, ao respeito
          &agrave; personalidade e &agrave; ordem p&uacute;blica digital.
        </p>
        <p className="mt-3 text-justify text-sm">
          &Eacute; vedado ao usu&aacute;rio, sob pena de
          responsabiliza&ccedil;&atilde;o nas esferas&nbsp;
          <strong>civil, administrativa e penal</strong>, praticar qualquer ato
          que infrinja direitos da GPMED LTDA, de outros usu&aacute;rios ou de
          terceiros. Dentre as condutas expressamente proibidas, destacam-se:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Criar ou utilizar perfis falsos</strong>, adulterar dados de
          identifica&ccedil;&atilde;o, utilizar informa&ccedil;&otilde;es de
          terceiros sem autoriza&ccedil;&atilde;o ou tentar mascarar sua
          identidade para acessar conte&uacute;dos ou funcionalidades
          indevidamente, configurando poss&iacute;vel pr&aacute;tica de&nbsp;
          <strong>falsidade ideol&oacute;gica</strong>
          &nbsp;(art. 299 do C&oacute;digo Penal);
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Acessar ou tentar acessar &aacute;reas restritas da Plataforma
          </strong>
          , manipular ou burlar sistemas de autentica&ccedil;&atilde;o,&nbsp;
          <strong>
            quebrar ou tentar quebrar medidas de seguran&ccedil;a digital
          </strong>
          &nbsp;(ex: firewalls, senhas, criptografia), inclusive por meio de
          engenharia reversa, scripts ou softwares automatizados;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Reproduzir, distribuir, divulgar, compartilhar, modificar, copiar ou
            comercializar qualquer conte&uacute;do disponibilizado pela GPMED
            LTDA
          </strong>
          , sem autoriza&ccedil;&atilde;o expressa, por escrito, sob pena de
          infring&ecirc;ncia de direitos autorais, propriedade intelectual e
          segredos comerciais, conforme disposto na&nbsp;
          <strong>Lei n&ordm; 9.610/1998</strong>
          &nbsp;(Lei de Direitos Autorais);
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Violar a privacidade, integridade ou honra de outros usu&aacute;rios
          </strong>
          , por qualquer meio, inclusive mediante a coleta indevida de dados
          pessoais, envio de mensagens ofensivas, ass&eacute;dio,
          discrimina&ccedil;&atilde;o ou exposi&ccedil;&atilde;o de
          informa&ccedil;&otilde;es sem consentimento, em afronta &agrave;&nbsp;
          <strong>LGPD</strong>, &agrave;&nbsp;
          <strong>
            Constitui&ccedil;&atilde;o Federal (art. 5&ordm;, incisos X e XII)
          </strong>
          &nbsp;e ao&nbsp;
          <strong>C&oacute;digo Civil (arts. 20 e 21)</strong>;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Praticar atos que comprometam a estabilidade, seguran&ccedil;a ou
            funcionalidade do Plataforma Digital GPMED,
          </strong>
          &nbsp;tais como introdu&ccedil;&atilde;o de v&iacute;rus,
          c&oacute;digos maliciosos, spam, sobrecarga de servidores ou
          explora&ccedil;&atilde;o de vulnerabilidades com finalidades
          il&iacute;citas ou danosas;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Utilizar linguagem ofensiva, discriminat&oacute;ria,
            difamat&oacute;ria, obscena, amea&ccedil;adora ou injuriosa
          </strong>
          &nbsp;em qualquer canal de intera&ccedil;&atilde;o da Plataforma (como
          atendimento, formul&aacute;rios ou coment&aacute;rios), bem como
          fomentar discurso de &oacute;dio, viol&ecirc;ncia, preconceito ou
          qualquer conduta incompat&iacute;vel com a conviv&ecirc;ncia
          civilizada em ambiente digital.
        </p>
        <p className="mt-3 text-justify text-sm">
          O descumprimento das regras de conduta ora estabelecidas autoriza, a
          exclusivo crit&eacute;rio da GPMED LTDA,&nbsp;
          <strong>
            a ado&ccedil;&atilde;o de medidas corretivas e sancionat&oacute;rias
            imediatas
          </strong>
          , tais como:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Advert&ecirc;ncia formal</strong>;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Suspens&atilde;o tempor&aacute;ria do acesso &agrave; conta
          </strong>
          ;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Cancelamento definitivo do cadastro do usu&aacute;rio infrator
          </strong>
          ;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Ado&ccedil;&atilde;o das medidas extrajudiciais e judiciais
            cab&iacute;veis
          </strong>
          , visando &agrave; repara&ccedil;&atilde;o de danos morais, materiais
          e &agrave; responsabiliza&ccedil;&atilde;o legal pelos atos
          praticados.
        </p>
        <p className="mt-3 text-justify text-sm">
          A GPMED LTDA reafirma que n&atilde;o tolerar&aacute; qualquer forma de
          desrespeito, uso abusivo ou ilegal da Plataforma e
          manter&aacute;&nbsp;
          <strong>pol&iacute;tica de toler&acirc;ncia zero</strong>
          &nbsp;quanto a condutas que afrontem os direitos da empresa, dos
          usu&aacute;rios ou da ordem p&uacute;blica digital.
        </p>
        <p className="mt-6 text-base">
          <strong>3. CADASTRO E CONTA DO USU&Aacute;RIO</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          Para que o usu&aacute;rio tenha&nbsp;
          <strong>acesso pleno, leg&iacute;timo e seguro</strong>
          &nbsp;&agrave;s funcionalidades ofertadas pela&nbsp;
          <strong>Plataforma Digital GPMED,</strong>
          &nbsp;&eacute; imprescind&iacute;vel a&nbsp;
          <strong>
            realiza&ccedil;&atilde;o de cadastro pr&eacute;vio, individual,
            completo e v&aacute;lido
          </strong>
          , por meio do fornecimento de informa&ccedil;&otilde;es de
          car&aacute;ter&nbsp;
          <strong>pessoal, profissional e de contato</strong>, as quais
          s&atilde;o essenciais &agrave; devida&nbsp;
          <strong>identifica&ccedil;&atilde;o do titular</strong>,
          &agrave;&nbsp;
          <strong>
            personaliza&ccedil;&atilde;o da experi&ecirc;ncia educacional
          </strong>
          &nbsp;oferecida, &agrave;&nbsp;
          <strong>seguran&ccedil;a dos sistemas</strong>
          &nbsp;e &agrave;&nbsp;
          <strong>
            preven&ccedil;&atilde;o de fraudes, acessos indevidos ou perfis
            falsos
          </strong>
          .
        </p>
        <p className="mt-3 text-justify text-sm">
          A exig&ecirc;ncia de cadastro encontra respaldo legal na&nbsp;
          <strong>
            Lei n&ordm; 12.965/2014 (Marco Civil da Internet, art. 7&ordm;, VII
            e VIII)
          </strong>
          , que garante o direito &agrave; prote&ccedil;&atilde;o dos dados
          pessoais e &agrave; exig&ecirc;ncia de consentimento informado, e
          na&nbsp;
          <strong>
            Lei n&ordm; 13.709/2018 (Lei Geral de Prote&ccedil;&atilde;o de
            Dados &ndash; LGPD, art. 7&ordm;, incisos I, II e V)
          </strong>
          , que autoriza o tratamento de dados pessoais para o cumprimento de
          obriga&ccedil;&atilde;o legal, execu&ccedil;&atilde;o de contrato e
          leg&iacute;timo interesse do controlador, desde que observados os
          direitos e liberdades fundamentais do titular.
        </p>
        <p className="mt-3 text-justify text-sm">
          O cadastro tem por finalidade:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Identificar e autenticar o usu&aacute;rio de forma inequ&iacute;voca
          </strong>
          , assegurando a legitimidade de suas a&ccedil;&otilde;es na
          Plataforma;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Assegurar a conformidade do plano de assinatura contratado
          </strong>
          , de acordo com o perfil profissional declarado (ex: estudante,
          residente, m&eacute;dico atuante);
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Viabilizar a presta&ccedil;&atilde;o dos servi&ccedil;os contratados
          </strong>
          , inclusive envio de conte&uacute;dos, avisos,
          atualiza&ccedil;&otilde;es e comunica&ccedil;&otilde;es operacionais;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Garantir a rastreabilidade e seguran&ccedil;a das
            intera&ccedil;&otilde;es
          </strong>
          , conforme exigido pelas boas pr&aacute;ticas de governan&ccedil;a em
          privacidade e prote&ccedil;&atilde;o de dados.
        </p>
        <p className="mt-3 text-justify text-sm">
          O preenchimento correto e verdadeiro do formul&aacute;rio de cadastro
          &eacute; condi&ccedil;&atilde;o indispens&aacute;vel para a
          cria&ccedil;&atilde;o da conta e manuten&ccedil;&atilde;o do acesso
          aos servi&ccedil;os. A aus&ecirc;ncia, falsidade, omiss&atilde;o ou
          imprecis&atilde;o das informa&ccedil;&otilde;es fornecidas
          poder&aacute; ensejar a&nbsp;
          <strong>
            recusa do cadastro, suspens&atilde;o de conta,
            limita&ccedil;&atilde;o de funcionalidades ou exclus&atilde;o
            definitiva do usu&aacute;rio da plataforma
          </strong>
          , sem preju&iacute;zo da responsabiliza&ccedil;&atilde;o nas esferas
          civil, administrativa e penal.
        </p>
        <p className="mt-3 text-justify text-sm">
          A GPMED LTDA, como controladora dos dados,&nbsp;
          <strong>respeita integralmente os princ&iacute;pios da LGPD</strong>,
          garantindo que os dados cadastrados:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Sejam&nbsp;
          <strong>
            tratados com finalidade leg&iacute;tima, espec&iacute;fica e
            informada
          </strong>
          &nbsp;ao titular;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Sejam&nbsp;
          <strong>coletados de forma adequada, pertinente e limitada</strong>
          &nbsp;ao m&iacute;nimo necess&aacute;rio para os prop&oacute;sitos da
          plataforma;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Sejam&nbsp;
          <strong>armazenados com seguran&ccedil;a</strong>
          &nbsp;e acess&iacute;veis apenas a pessoas autorizadas;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Possam ser&nbsp;
          <strong>corrigidos, atualizados ou exclu&iacute;dos</strong>
          &nbsp;mediante solicita&ccedil;&atilde;o expressa do titular, nos
          termos do artigo 18 da LGPD.
        </p>
        <p className="mt-3 text-justify text-sm">
          A cria&ccedil;&atilde;o da conta implica na&nbsp;
          <strong>
            manifesta&ccedil;&atilde;o inequ&iacute;voca de consentimento do
            usu&aacute;rio
          </strong>
          &nbsp;para o tratamento de seus dados pessoais nos termos descritos
          nesta Pol&iacute;tica, com base legal no artigo 7&ordm;, inciso I da
          LGPD, salvo nas hip&oacute;teses em que o tratamento se fundamente em
          outra base legal aplic&aacute;vel.
        </p>
        <p className="mt-3 text-justify text-sm">
          Por fim, a GPMED LTDA reitera que n&atilde;o se responsabiliza por
          consequ&ecirc;ncias decorrentes de&nbsp;
          <strong>
            informa&ccedil;&otilde;es inver&iacute;dicas, desatualizadas ou
            prestadas por terceiros sem autoriza&ccedil;&atilde;o
          </strong>
          , sendo o usu&aacute;rio o &uacute;nico respons&aacute;vel pela
          integridade, seguran&ccedil;a e atualiza&ccedil;&atilde;o de seus
          dados cadastrais.
        </p>
        <p className="mt-3 text-justify text-sm">
          <strong>3.1 Informa&ccedil;&otilde;es Exigidas no Cadastro</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          Para que o usu&aacute;rio tenha acesso regular e autorizado a&nbsp;
          <strong>Plataforma Digital GPMED </strong>e &agrave;s funcionalidades
          disponibilizadas pela plataforma, ser&aacute; necess&aacute;rio
          realizar um&nbsp;
          <strong>cadastro pr&eacute;vio e obrigat&oacute;rio</strong>, mediante
          o fornecimento de dados pessoais e profissionais, cuja coleta se
          justifica por&nbsp;
          <strong>
            finalidades leg&iacute;timas, espec&iacute;ficas e informadas
          </strong>
          , conforme estabelecido pela&nbsp;
          <strong>
            Lei Geral de Prote&ccedil;&atilde;o de Dados Pessoais (LGPD &ndash;
            Lei n&ordm; 13.709/2018)
          </strong>
          .
        </p>
        <p className="mt-3 text-justify text-sm">
          As informa&ccedil;&otilde;es m&iacute;nimas e essenciais que
          dever&atilde;o ser obrigatoriamente fornecidas no ato do cadastro
          s&atilde;o:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Nome completo do usu&aacute;rio:</strong>
          &nbsp;para identifica&ccedil;&atilde;o pessoal e emiss&atilde;o de
          documentos relacionados ao servi&ccedil;o;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Endere&ccedil;o de e-mail v&aacute;lido:</strong>
          &nbsp;para fins de comunica&ccedil;&atilde;o institucional, envio de
          informa&ccedil;&otilde;es contratuais, notifica&ccedil;&otilde;es de
          seguran&ccedil;a, autentica&ccedil;&atilde;o de acesso e
          recupera&ccedil;&atilde;o de senha;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>N&uacute;mero de telefone celular ativo:</strong>
          &nbsp;para valida&ccedil;&otilde;es de seguran&ccedil;a,
          autentica&ccedil;&otilde;es em duas etapas (quando aplic&aacute;vel) e
          comunica&ccedil;&atilde;o r&aacute;pida em situa&ccedil;&otilde;es
          operacionais;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Senha de acesso pessoal e intransfer&iacute;vel:</strong>
          &nbsp;definida pelo pr&oacute;prio usu&aacute;rio, sob
          responsabilidade exclusiva quanto &agrave; sua guarda e uso;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Sele&ccedil;&atilde;o do plano de assinatura (quando
            aplic&aacute;vel):
          </strong>
          &nbsp;para defini&ccedil;&atilde;o da modalidade de acesso e
          personaliza&ccedil;&atilde;o dos servi&ccedil;os contratados.
        </p>
        <p className="mt-3 text-justify text-sm">
          Adicionalmente,&nbsp;
          <strong>
            em conson&acirc;ncia com o perfil declarado e as regras de
            elegibilidade aos planos de assinatura diferenciados
          </strong>
          , a plataforma poder&aacute; solicitar informa&ccedil;&otilde;es
          complementares, tais como:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>N&uacute;mero do CRM (opcional):</strong>
          &nbsp;para fins de categoriza&ccedil;&atilde;o profissional e
          adequa&ccedil;&atilde;o da oferta de conte&uacute;do aos
          m&eacute;dicos regularmente registrados;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Comprovante de matr&iacute;cula ou v&iacute;nculo com
            institui&ccedil;&atilde;o de ensino superior da &aacute;rea da
            sa&uacute;de (para estudantes):
          </strong>
          &nbsp;necess&aacute;rio &agrave; valida&ccedil;&atilde;o da
          condi&ccedil;&atilde;o estudantil e eventual acesso a planos
          espec&iacute;ficos com benef&iacute;cios exclusivos;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Comprovante de resid&ecirc;ncia m&eacute;dica (quando
            aplic&aacute;vel):
          </strong>
          &nbsp;documento destinado &agrave; verifica&ccedil;&atilde;o da fase
          de forma&ccedil;&atilde;o profissional, visando ajustar os recursos e
          a experi&ecirc;ncia de uso ao perfil do usu&aacute;rio.
        </p>
        <p className="mt-3 text-justify text-sm">
          A GPMED LTDA poder&aacute;, sempre que necess&aacute;rio,&nbsp;
          <strong>
            verificar a veracidade e autenticidade das informa&ccedil;&otilde;es
            e documentos fornecidos
          </strong>
          , inclusive por meio de contato com a institui&ccedil;&atilde;o
          emissora ou por meio de outros mecanismos legalmente admitidos, em
          conformidade com o artigo 7&ordm;, inciso II da LGPD, que autoriza o
          tratamento de dados para o cumprimento de obriga&ccedil;&otilde;es
          legais e contratuais.
        </p>
        <p className="mt-3 text-justify text-sm">
          Todos os dados informados ser&atilde;o tratados com estrita
          observ&acirc;ncia aos&nbsp;
          <strong>
            princ&iacute;pios da finalidade, necessidade,
            adequa&ccedil;&atilde;o, seguran&ccedil;a e transpar&ecirc;ncia
          </strong>
          , n&atilde;o sendo utilizados para quaisquer prop&oacute;sitos que
          n&atilde;o estejam previamente informados ou que contrariem os
          direitos e interesses leg&iacute;timos do titular, conforme previsto
          nos artigos 6&ordm; e 18 da LGPD.
        </p>
        <p className="mt-3 text-justify text-sm">
          O fornecimento das informa&ccedil;&otilde;es requeridas no cadastro
          representa&nbsp;
          <strong>
            condi&ccedil;&atilde;o essencial para a cria&ccedil;&atilde;o da
            conta de acesso
          </strong>
          , sendo de responsabilidade exclusiva do usu&aacute;rio garantir a
          veracidade, completude e atualiza&ccedil;&atilde;o cont&iacute;nua dos
          dados fornecidos, sob pena de bloqueio de funcionalidades,
          suspens&atilde;o de acesso ou exclus&atilde;o da conta, nos termos da
          legisla&ccedil;&atilde;o aplic&aacute;vel e das
          disposi&ccedil;&otilde;es contratuais aqui estabelecidas.
        </p>
        <p className="mt-3 text-justify text-sm">
          <strong>
            3.2 Veracidade, Atualiza&ccedil;&atilde;o e Responsabilidade sobre
            os Dados
          </strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          O usu&aacute;rio da&nbsp;
          <strong>Plataforma Digital GPMED </strong>
          reconhece e declara, para todos os fins legais, que &eacute; o&nbsp;
          <strong>
            &uacute;nico e exclusivo respons&aacute;vel pela veracidade,
            integridade, completude, precis&atilde;o, autenticidade e
            atualiza&ccedil;&atilde;o das informa&ccedil;&otilde;es pessoais e
            profissionais fornecidas no momento do cadastro e durante toda a
            vig&ecirc;ncia da rela&ccedil;&atilde;o contratual com a plataforma
          </strong>
          .
        </p>
        <p className="mt-3 text-justify text-sm">
          O fornecimento de dados corretos, fidedignos e atualizados constitui
          requisito essencial para a cria&ccedil;&atilde;o e
          manuten&ccedil;&atilde;o da conta de acesso, bem como para a adequada
          presta&ccedil;&atilde;o dos servi&ccedil;os oferecidos. O
          usu&aacute;rio compromete-se a&nbsp;
          <strong>
            atualizar prontamente seus dados sempre que houver qualquer
            modifica&ccedil;&atilde;o relevante
          </strong>
          , sob pena de comprometimento da seguran&ccedil;a, da
          comunica&ccedil;&atilde;o institucional e da pr&oacute;pria validade
          da rela&ccedil;&atilde;o contratual.
        </p>
        <p className="mt-3 text-justify text-sm">
          A presta&ccedil;&atilde;o de informa&ccedil;&otilde;es falsas,
          incompletas, inver&iacute;dicas ou fraudulentas ser&aacute;
          considerada&nbsp;
          <strong>infra&ccedil;&atilde;o grave deste contrato</strong>,
          ensejando, a exclusivo crit&eacute;rio da GPMED LTDA:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            A suspens&atilde;o tempor&aacute;ria da conta do usu&aacute;rio
          </strong>
          ;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            A limita&ccedil;&atilde;o ou bloqueio do acesso &agrave;s
            funcionalidades
          </strong>
          &nbsp;da plataforma;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            A exclus&atilde;o definitiva do perfil do usu&aacute;rio
          </strong>
          , com rescis&atilde;o contratual imediata;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            A responsabiliza&ccedil;&atilde;o nas esferas c&iacute;vel,
            administrativa e penal
          </strong>
          , conforme previsto na legisla&ccedil;&atilde;o aplic&aacute;vel,
          inclusive nos&nbsp;
          <strong>
            artigos 171 (estelionato) e 299 (falsidade ideol&oacute;gica) do
            C&oacute;digo Penal Brasileiro
          </strong>
          .
        </p>
        <p className="mt-3 text-justify text-sm">
          Nos termos do&nbsp;
          <strong>
            artigo 14 do C&oacute;digo de Defesa do Consumidor (Lei n&ordm;
            8.078/1990)
          </strong>
          , a responsabilidade do fornecedor de servi&ccedil;os por danos
          causados ao consumidor est&aacute; diretamente relacionada &agrave;
          qualidade das informa&ccedil;&otilde;es fornecidas pelo
          usu&aacute;rio, raz&atilde;o pela qual &eacute; essencial que os dados
          declarados sejam exatos e verdadeiros.
        </p>
        <p className="mt-3 text-justify text-sm">
          O usu&aacute;rio tamb&eacute;m se compromete a&nbsp;
          <strong>
            manter sob sigilo absoluto suas credenciais de acesso &agrave; conta
            (login e senha)
          </strong>
          , n&atilde;o devendo em hip&oacute;tese alguma compartilh&aacute;-las
          com terceiros. Toda e qualquer atividade realizada dentro da
          plataforma mediante login v&aacute;lido ser&aacute; considerada como
          tendo sido praticada pelo titular da conta, que&nbsp;
          <strong>
            responder&aacute; integralmente pelos atos praticados e pelas
            consequ&ecirc;ncias decorrentes
          </strong>
          , ainda que por a&ccedil;&atilde;o de terceiros, nos termos do&nbsp;
          <strong>
            artigo 10 do Marco Civil da Internet (Lei n&ordm; 12.965/2014)
          </strong>
          .
        </p>
        <p className="mt-3 text-justify text-sm">
          A GPMED LTDA isenta-se de qualquer responsabilidade decorrente de
          acessos indevidos causados por&nbsp;
          <strong>
            neglig&ecirc;ncia, imprud&ecirc;ncia ou imper&iacute;cia do
            pr&oacute;prio usu&aacute;rio na guarda de suas
            informa&ccedil;&otilde;es de autentica&ccedil;&atilde;o
          </strong>
          , cabendo a este adotar todas as medidas razo&aacute;veis de
          prote&ccedil;&atilde;o, como o uso de senhas seguras e a troca
          peri&oacute;dica das mesmas.
        </p>

        <p className="mt-3 text-justify text-sm">
          <strong>
            3.3 Exclus&atilde;o, Suspens&atilde;o e Restri&ccedil;&atilde;o de
            Contas
          </strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          A&nbsp;
          <strong>GPMED Plataforma Digital</strong>
          &nbsp;reserva-se o direito de adotar, a qualquer tempo e com base na
          boa-f&eacute; contratual, medidas administrativas de&nbsp;
          <strong>
            suspens&atilde;o tempor&aacute;ria, limita&ccedil;&atilde;o de
            acesso a funcionalidades ou exclus&atilde;o definitiva de contas de
            usu&aacute;rios
          </strong>
          , desde que devidamente motivadas e em conformidade com os
          princ&iacute;pios do contradit&oacute;rio, da ampla defesa e da
          transpar&ecirc;ncia.
        </p>
        <p className="mt-3 text-justify text-sm">
          Essas medidas poder&atilde;o ser aplicadas, de forma individualizada,
          nas seguintes hip&oacute;teses, exemplificativamente:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Constata&ccedil;&atilde;o de inconsist&ecirc;ncias, irregularidades,
            omiss&otilde;es relevantes ou falsidade nas
            informa&ccedil;&otilde;es prestadas pelo usu&aacute;rio
          </strong>
          , seja no momento do cadastro ou durante a rela&ccedil;&atilde;o
          contratual, inclusive mediante a apresenta&ccedil;&atilde;o de
          documentos inv&aacute;lidos ou inver&iacute;dicos, nos termos dos
          artigos 171 e 299 do C&oacute;digo Penal;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Descumprimento, pelo usu&aacute;rio, das regras de conduta, dos
            deveres contratuais ou legais estabelecidos nesta Pol&iacute;tica de
            Uso
          </strong>
          , incluindo a pr&aacute;tica de atos ofensivos,
          discriminat&oacute;rios, il&iacute;citos ou incompat&iacute;veis com a
          finalidade da plataforma;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Uso indevido, abusivo ou ilegal da aplica&ccedil;&atilde;o
          </strong>
          , ainda que por meio de terceiros, que implique em risco &agrave;
          integridade da plataforma, &agrave; seguran&ccedil;a da
          informa&ccedil;&atilde;o, ao sistema de pagamento, ou que cause danos
          ou preju&iacute;zos &agrave; GPMED LTDA, a outros usu&aacute;rios ou a
          terceiros;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Inatividade prolongada da conta por per&iacute;odo cont&iacute;nuo
            superior a 12 (doze) meses
          </strong>
          , hip&oacute;tese em que poder&aacute; ser realizada a exclus&atilde;o
          do perfil mediante notifica&ccedil;&atilde;o pr&eacute;via enviada ao
          endere&ccedil;o eletr&ocirc;nico cadastrado;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Solicita&ccedil;&atilde;o expressa do pr&oacute;prio titular dos
            dados
          </strong>
          , por meio dos canais oficiais de atendimento disponibilizados pela
          GPMED LTDA, ocasi&atilde;o em que a conta ser&aacute; encerrada de
          forma definitiva, respeitadas as obriga&ccedil;&otilde;es legais
          pendentes.
        </p>
        <p className="mt-3 text-justify text-sm">
          Nos casos de exclus&atilde;o volunt&aacute;ria por iniciativa do
          titular, este poder&aacute; tamb&eacute;m requerer a&nbsp;
          <strong>
            elimina&ccedil;&atilde;o definitiva dos seus dados pessoais
            armazenados
          </strong>
          , nos termos do artigo 18, inciso VI da&nbsp;
          <strong>LGPD</strong>, observadas, contudo, as&nbsp;
          <strong>
            exce&ccedil;&otilde;es legais previstas nos artigos 15 e 16 da mesma
            norma
          </strong>
          , especialmente quando os dados forem necess&aacute;rios para
          cumprimento de obriga&ccedil;&otilde;es legais ou regulat&oacute;rias,
          exerc&iacute;cio regular de direitos, defesa em processos judiciais ou
          administrativos, ou ainda para resguardo do leg&iacute;timo interesse
          da GPMED LTDA, devidamente justificado.
        </p>
        <p className="mt-3 text-justify text-sm">
          A GPMED LTDA assegura ao usu&aacute;rio o&nbsp;
          <strong>
            direito de revis&atilde;o de decis&otilde;es automatizadas
          </strong>
          &nbsp;que resultem na suspens&atilde;o ou exclus&atilde;o de sua
          conta, conforme estabelecido no artigo 20 da LGPD. Para tanto, o
          usu&aacute;rio poder&aacute; apresentar&nbsp;
          <strong>
            solicita&ccedil;&atilde;o formal, motivada e fundamentada
          </strong>
          , atrav&eacute;s do canal de atendimento oficial da plataforma, no
          endere&ccedil;o eletr&ocirc;nico:&nbsp;
          <strong>contato@oguiadeprescricao.com.br</strong>.
        </p>
        <p className="mt-3 text-justify text-sm">
          Todas as a&ccedil;&otilde;es administrativas adotadas pela GPMED LTDA
          ter&atilde;o por base crit&eacute;rios objetivos, proporcionais e
          razo&aacute;veis, em respeito aos princ&iacute;pios da&nbsp;
          <strong>
            legalidade, transpar&ecirc;ncia, seguran&ccedil;a e boa-f&eacute;
          </strong>
          , sendo preservados os registros necess&aacute;rios para eventual
          auditoria, defesa e responsabiliza&ccedil;&atilde;o conforme o caso.
        </p>

        <p className="mt-6 text-justify text-base">
          <strong>4. PLANO DE PAGAMENTO E COBRAN&Ccedil;A RECORRENTE</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          O acesso integral e cont&iacute;nuo a funcionalidades
          espec&iacute;ficas, conte&uacute;dos premium e recursos exclusivos
          da&nbsp;
          <strong>Plataforma Digital GPMED </strong>
          est&aacute; condicionado &agrave;&nbsp;
          <strong>
            contrata&ccedil;&atilde;o de planos de assinatura pagos
          </strong>
          , os quais operam sob o regime de&nbsp;
          <strong>cobran&ccedil;a peri&oacute;dica e recorrente</strong>,
          conforme os termos e condi&ccedil;&otilde;es previstos neste
          instrumento contratual.
        </p>
        <p className="mt-3 text-justify text-sm">
          A ades&atilde;o aos planos ocorre de forma&nbsp;
          <strong>
            volunt&aacute;ria, informada, transparente e inequ&iacute;voca
          </strong>
          , mediante concord&acirc;ncia expressa do usu&aacute;rio com os
          valores, periodicidade, forma de pagamento e obriga&ccedil;&otilde;es
          contratuais vinculadas &agrave; modalidade escolhida. O modelo de
          assinatura digital, aqui aplicado, configura&nbsp;
          <strong>contrato eletr&ocirc;nico de ades&atilde;o</strong>,
          v&aacute;lido juridicamente nos termos do&nbsp;
          <strong>artigo 421-A do C&oacute;digo Civil Brasileiro</strong>, com
          plena efic&aacute;cia legal, desde que celebrado com consentimento
          v&aacute;lido e em ambiente seguro.
        </p>
        <p className="mt-3 text-justify text-sm">
          A contrata&ccedil;&atilde;o dos planos e o processamento dos
          respectivos pagamentos obedecem &agrave;s garantias e direitos
          assegurados aos consumidores, notadamente os constantes no&nbsp;
          <strong>C&oacute;digo de Defesa do Consumidor (CDC)</strong>,
          garantindo-se:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Direito &agrave; informa&ccedil;&atilde;o clara e adequada (art.
          6&ordm;, III);
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Prote&ccedil;&atilde;o contra cl&aacute;usulas abusivas (art. 51);
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Direito de arrependimento em compras digitais (art. 49);
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Transpar&ecirc;ncia e boa-f&eacute; objetiva nas
          rela&ccedil;&otilde;es contratuais (arts. 4&ordm; e 6&ordm;).
        </p>
        <p className="mt-3 text-justify text-sm">
          A&nbsp;
          <strong>cobran&ccedil;a recorrente</strong>
          &nbsp;refere-se ao modelo no qual, ap&oacute;s o primeiro pagamento
          realizado pelo usu&aacute;rio, os valores subsequentes s&atilde;o
          debitados automaticamente, com periodicidade previamente definida
          (mensal ou anual), at&eacute; que haja o&nbsp;
          <strong>cancelamento formal da assinatura</strong>
          &nbsp;por parte do titular ou a rescis&atilde;o contratual pela GPMED
          LTDA, nos termos e prazos estipulados.
        </p>
        <p className="mt-3 text-justify text-sm">
          Todos os valores cobrados, formas de pagamento aceitas (como
          cart&atilde;o de cr&eacute;dito, d&eacute;bito autom&aacute;tico ou
          outros meios eletr&ocirc;nicos autorizados) e condi&ccedil;&otilde;es
          espec&iacute;ficas de cada plano s&atilde;o previamente apresentados
          ao usu&aacute;rio&nbsp;
          <strong>
            de forma destacada, acess&iacute;vel e intelig&iacute;vel
          </strong>
          , em ambiente seguro e antes da confirma&ccedil;&atilde;o da
          contrata&ccedil;&atilde;o, em conformidade com os princ&iacute;pios
          do&nbsp;
          <strong>
            direito &agrave; informa&ccedil;&atilde;o e &agrave;
            transpar&ecirc;ncia
          </strong>
          .
        </p>
        <p className="mt-3 text-justify text-sm">
          A ades&atilde;o a qualquer plano de assinatura implica a
          autoriza&ccedil;&atilde;o expressa do usu&aacute;rio para o&nbsp;
          <strong>
            processamento automatizado dos pagamentos peri&oacute;dicos
          </strong>
          , observadas as normas de seguran&ccedil;a da
          informa&ccedil;&atilde;o, privacidade de dados financeiros e sigilo
          das opera&ccedil;&otilde;es, conforme previsto na&nbsp;
          <strong>LGPD (art. 6&ordm;, incisos VII e VIII)</strong>, sendo vedado
          o uso dos dados banc&aacute;rios para finalidades distintas daquelas
          informadas ou em desconformidade com o consentimento do titular.
        </p>
        <p className="mt-3 text-justify text-sm">
          A GPMED LTDA compromete-se a adotar&nbsp;
          <strong>
            medidas t&eacute;cnicas e administrativas adequadas para
            prote&ccedil;&atilde;o das transa&ccedil;&otilde;es financeiras
          </strong>
          , por meio de parcerias com plataformas de pagamento
          confi&aacute;veis, certificadas por padr&otilde;es internacionais de
          seguran&ccedil;a (como PCI DSS), garantindo a confidencialidade,
          integridade e disponibilidade das informa&ccedil;&otilde;es.
        </p>
        <p className="mt-3 text-justify text-sm">
          O usu&aacute;rio poder&aacute;, a qualquer tempo, consultar os termos
          aplic&aacute;veis ao seu plano, inclusive&nbsp;
          <strong>
            dados de cobran&ccedil;a, ciclo de renova&ccedil;&atilde;o e
            hist&oacute;rico de pagamentos
          </strong>
          , acessando o painel da sua conta dentro da Plataforma Digital GPMED
          ou entrando em contato pelos canais oficiais de atendimento.
        </p>
        <p className="mt-3 text-justify text-sm">
          Eventuais d&uacute;vidas, diverg&ecirc;ncias ou
          solicita&ccedil;&otilde;es de esclarecimento sobre cobran&ccedil;as
          dever&atilde;o ser comunicadas &agrave; GPMED LTDA imediatamente, para
          que sejam tomadas as provid&ecirc;ncias necess&aacute;rias com base no
          princ&iacute;pio da boa-f&eacute; e na busca da solu&ccedil;&atilde;o
          mais justa, nos termos do&nbsp;
          <strong>artigo 6&ordm;, inciso V do CDC</strong>.
        </p>

        <p className="mt-3 text-justify text-sm">
          <strong>4.1 Modelo de Assinatura</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          A&nbsp;
          <strong>GPMED Plataforma Digital</strong>
          &nbsp;adota o&nbsp;
          <strong>modelo de assinatura digital por ades&atilde;o</strong>,
          caracterizado pela contrata&ccedil;&atilde;o realizada de forma
          eletr&ocirc;nica, diretamente pelo usu&aacute;rio, dentro do ambiente
          seguro e autenticado do&nbsp;
          <strong>Plataforma Digital GPMED,</strong>
          &nbsp;mediante&nbsp;
          <strong>
            aceita&ccedil;&atilde;o expressa, pr&eacute;via e informada
          </strong>
          &nbsp;dos&nbsp;
          <strong>Termos de Uso</strong>
          &nbsp;e da&nbsp;
          <strong>Pol&iacute;tica de Privacidade</strong>, em conformidade com o
          disposto no&nbsp;
          <strong>artigo 421-A do C&oacute;digo Civil Brasileiro</strong>
          &nbsp;e no&nbsp;
          <strong>
            artigo 7&ordm;, IX, do Marco Civil da Internet (Lei n&ordm;
            12.965/2014)
          </strong>
          .
        </p>
        <p className="mt-3 text-justify text-sm">
          A formaliza&ccedil;&atilde;o da assinatura digital implica a
          forma&ccedil;&atilde;o de v&iacute;nculo jur&iacute;dico contratual,
          com plena validade legal, equivalendo &agrave;
          celebra&ccedil;&atilde;o de contrato por escrito, conforme
          interpreta&ccedil;&atilde;o doutrin&aacute;ria e jurisprudencial
          vigente. O aceite &eacute; registrado eletronicamente, com o
          respectivo registro de data, hora, IP e demais metadados
          necess&aacute;rios &agrave; comprova&ccedil;&atilde;o da
          manifesta&ccedil;&atilde;o de vontade livre e inequ&iacute;voca do
          usu&aacute;rio.
        </p>
        <p className="mt-3 text-justify text-sm">
          A assinatura contratada confere ao usu&aacute;rio&nbsp;
          <strong>
            acesso restrito e exclusivo aos conte&uacute;dos premium da
            plataforma
          </strong>
          , organizados conforme o perfil declarado no momento do cadastro,
          podendo incluir: materiais educacionais especializados, trilhas de
          aprendizagem segmentadas por n&iacute;vel de forma&ccedil;&atilde;o
          (acad&ecirc;mico, residente, profissional atuante), ferramentas de
          apoio, atualiza&ccedil;&otilde;es e outras funcionalidades adicionais,
          cuja disponibilidade estar&aacute; atrelada ao plano ativo.
        </p>

        <p className="mt-3 text-justify text-sm">
          A vig&ecirc;ncia da assinatura poder&aacute; ser estabelecida
          por&nbsp;
          <strong>per&iacute;odo mensal ou anual</strong>, a depender da
          modalidade selecionada pelo usu&aacute;rio no momento da
          contrata&ccedil;&atilde;o, sendo o ciclo de cobran&ccedil;a
          correspondente&nbsp;
          <strong>executado de forma autom&aacute;tica e recorrente</strong>,
          at&eacute; que haja a&nbsp;
          <strong>
            solicita&ccedil;&atilde;o formal de cancelamento pelo titular
          </strong>
          &nbsp;ou&nbsp;
          <strong>rescis&atilde;o contratual pela GPMED LTDA</strong>, nos
          termos e condi&ccedil;&otilde;es estabelecidos nesta Pol&iacute;tica.
        </p>
        <p className="mt-3 text-justify text-sm">
          A renova&ccedil;&atilde;o da assinatura ocorre de forma
          cont&iacute;nua, preservando-se as condi&ccedil;&otilde;es
          anteriormente acordadas, exceto nos casos de&nbsp;
          <strong>
            altera&ccedil;&atilde;o de pre&ccedil;o, mudan&ccedil;a contratual
            significativa ou t&eacute;rmino do plano contratado
          </strong>
          , os quais ser&atilde;o sempre informados previamente ao
          usu&aacute;rio, em respeito ao direito &agrave;
          informa&ccedil;&atilde;o (art. 6&ordm;, III, do CDC).
        </p>
        <p className="mt-3 text-justify text-sm">
          Durante todo o per&iacute;odo de vig&ecirc;ncia contratual, o
          usu&aacute;rio ter&aacute; direito ao suporte t&eacute;cnico e ao
          acesso irrestrito aos servi&ccedil;os adquiridos, desde que em
          situa&ccedil;&atilde;o regular de pagamento, estando vedado o
          compartilhamento de contas, a revenda de acessos ou qualquer forma de
          cess&atilde;o n&atilde;o autorizada, sob pena de bloqueio imediato e
          responsabiliza&ccedil;&atilde;o civil e criminal.
        </p>
        <p className="mt-3 text-justify text-sm">
          A contrata&ccedil;&atilde;o e a manuten&ccedil;&atilde;o da assinatura
          pressup&otilde;em a concord&acirc;ncia com as regras de uso, os
          crit&eacute;rios de elegibilidade dos planos e as pol&iacute;ticas
          internas de seguran&ccedil;a e privacidade da GPMED LTDA, que
          poder&atilde;o ser revistas a qualquer tempo para garantir a
          conformidade com a legisla&ccedil;&atilde;o aplic&aacute;vel e as boas
          pr&aacute;ticas de mercado.
        </p>
        <p className="mt-3 text-justify text-sm">
          <strong>
            4.2 Valor, Periodicidade, Forma de Pagamento e Pol&iacute;tica de
            Reajuste
          </strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          Os valores dos&nbsp;
          <strong>planos de assinatura</strong>
          &nbsp;oferecidos pela&nbsp;
          <strong>Plataforma Digital GPMED </strong>
          s&atilde;o definidos com base em crit&eacute;rios de razoabilidade,
          equil&iacute;brio contratual e adequa&ccedil;&atilde;o &agrave;
          proposta de valor de cada modalidade de acesso. Esses valores
          poder&atilde;o variar conforme o&nbsp;
          <strong>tipo de plano contratado</strong>, o&nbsp;
          <strong>perfil do usu&aacute;rio</strong>
          &nbsp;(como estudantes, residentes ou m&eacute;dicos atuantes), bem
          como em decorr&ecirc;ncia de&nbsp;
          <strong>
            a&ccedil;&otilde;es promocionais, descontos tempor&aacute;rios,
            parcerias institucionais ou ofertas sazonais
          </strong>
          .
        </p>
        <p className="mt-3 text-justify text-sm">
          Todas as informa&ccedil;&otilde;es relativas aos pre&ccedil;os, formas
          de pagamento, benef&iacute;cios e condi&ccedil;&otilde;es contratuais
          s&atilde;o disponibilizadas de forma&nbsp;
          <strong>clara, ostensiva e acess&iacute;vel</strong>, dentro do
          ambiente do&nbsp;
          <strong>Plataforma Digital GPMED,</strong>
          &nbsp;
          <strong>
            antes da finaliza&ccedil;&atilde;o da contrata&ccedil;&atilde;o
          </strong>
          , em estrita observ&acirc;ncia ao&nbsp;
          <strong>
            princ&iacute;pio da transpar&ecirc;ncia e &agrave;
            prote&ccedil;&atilde;o contratual do consumidor
          </strong>
          , conforme previsto nos artigos 6&ordm;, incisos III e IV, e 30 a 46
          do&nbsp;
          <strong>
            C&oacute;digo de Defesa do Consumidor (Lei n&ordm; 8.078/1990)
          </strong>
          .
        </p>
        <p className="mt-3 text-justify text-sm">
          A&nbsp;
          <strong>periodicidade da cobran&ccedil;a</strong>
          &nbsp;ser&aacute; definida conforme a op&ccedil;&atilde;o contratada
          pelo usu&aacute;rio no momento da ades&atilde;o ao plano, podendo
          ser&nbsp;
          <strong>mensal ou anual</strong>, com renova&ccedil;&atilde;o
          autom&aacute;tica ao t&eacute;rmino de cada ciclo, salvo
          manifesta&ccedil;&atilde;o expressa em sentido contr&aacute;rio,
          observadas as disposi&ccedil;&otilde;es contratuais sobre
          cancelamento.
        </p>
        <p className="mt-3 text-justify text-sm">
          O&nbsp;
          <strong>pagamento das assinaturas</strong>
          &nbsp;ser&aacute; processado, preferencialmente, por meio de
          plataformas seguras de intermedia&ccedil;&atilde;o financeira,
          utilizando-se dos seguintes meios eletr&ocirc;nicos:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Cart&atilde;o de cr&eacute;dito</strong>
          &nbsp;(com op&ccedil;&atilde;o de cobran&ccedil;a recorrente
          autorizada);
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>D&eacute;bito autom&aacute;tico em conta corrente</strong>,
          quando dispon&iacute;vel e operacionalmente vi&aacute;vel;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Outras modalidades de pagamento digital</strong>, conforme
          integra&ccedil;&atilde;o com sistemas certificados e autorizados pela
          GPMED LTDA.
        </p>
        <p className="mt-3 text-justify text-sm">
          O processamento das informa&ccedil;&otilde;es financeiras ser&aacute;
          realizado de maneira&nbsp;
          <strong>
            segura, criptografada e em conformidade com as melhores
            pr&aacute;ticas internacionais de prote&ccedil;&atilde;o de dados
            banc&aacute;rios
          </strong>
          , n&atilde;o sendo armazenados dados sens&iacute;veis do cart&atilde;o
          de cr&eacute;dito (como c&oacute;digo CVV) pela GPMED LTDA, em
          aten&ccedil;&atilde;o &agrave;&nbsp;
          <strong>
            Lei Geral de Prote&ccedil;&atilde;o de Dados Pessoais (LGPD &ndash;
            Lei n&ordm; 13.709/2018, arts. 6&ordm; e 46)
          </strong>
          .
        </p>
        <p className="mt-3 text-justify text-sm">
          A GPMED LTDA reserva-se o direito de&nbsp;
          <strong>
            reajustar os valores dos planos de assinatura a qualquer tempo
          </strong>
          , por raz&otilde;es econ&ocirc;micas, operacionais, t&eacute;cnicas ou
          de mercado, desde que&nbsp;
          <strong>
            comunique previamente o usu&aacute;rio com anteced&ecirc;ncia
            m&iacute;nima de 30 (trinta) dias
          </strong>
          , nos termos do&nbsp;
          <strong>
            artigo 6&ordm;, inciso III, e do artigo 39, inciso X, do
            C&oacute;digo de Defesa do Consumidor
          </strong>
          .
        </p>
        <p className="mt-3 text-justify text-sm">
          Os reajustes poder&atilde;o ter como base:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>&Iacute;ndices oficiais de infla&ccedil;&atilde;o</strong>
          &nbsp;divulgados por entidades p&uacute;blicas reconhecidas (ex: IPCA,
          IGPM);
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Revis&atilde;o do escopo e da complexidade dos servi&ccedil;os
            ofertados
          </strong>
          ;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Altera&ccedil;&otilde;es legais ou regulat&oacute;rias
          </strong>
          &nbsp;que impactem diretamente na estrutura de custos ou no modelo de
          neg&oacute;cio da empresa.
        </p>
        <p className="mt-3 text-justify text-sm">
          A manuten&ccedil;&atilde;o da assinatura ap&oacute;s o prazo de
          comunica&ccedil;&atilde;o pr&eacute;via ser&aacute; interpretada
          como&nbsp;
          <strong>
            concord&acirc;ncia t&aacute;cita com os novos valores praticados
          </strong>
          , sem preju&iacute;zo do direito de cancelamento a qualquer tempo, nos
          termos das cl&aacute;usulas aplic&aacute;veis desta Pol&iacute;tica.
        </p>
        <p className="mt-3 text-justify text-sm">
          <strong>
            4.3 Cancelamento, Reembolso e Renova&ccedil;&atilde;o
            Autom&aacute;tica
          </strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          O usu&aacute;rio da&nbsp;
          <strong>Plataforma Digital GPMED </strong>
          poder&aacute; solicitar o cancelamento de sua assinatura a qualquer
          momento de forma livre e volunt&aacute;ria, sem necessidade de
          justificativa, desde que por meio das ferramentas dispon&iacute;veis
          dentro da pr&oacute;pria plataforma ou mediante
          solicita&ccedil;&atilde;o encaminhada aos&nbsp;
          <strong>canais oficiais de atendimento</strong>, especialmente no
          endere&ccedil;o eletr&ocirc;nico:&nbsp;
          <strong>cancelamento@oguiadeprescricao.com.br</strong>.
        </p>
        <p className="mt-3 text-justify text-sm">
          Em caso de planos anuais, o cancelamento imotivado ap&oacute;s os 7
          (sete) dias do direito de arrependimento n&atilde;o enseja reembolso
          proporcional.&nbsp;
        </p>
        <p className="mt-3 text-justify text-sm">
          Contudo, em situa&ccedil;&otilde;es excepcionais devidamente
          comprovadas, como falhas na presta&ccedil;&atilde;o do servi&ccedil;o
          ou indisponibilidade grave, a GPMED LTDA poder&aacute;, a seu
          crit&eacute;rio, autorizar reembolso proporcional, com base nos
          princ&iacute;pios da boa-f&eacute;, equidade e equil&iacute;brio
          contratual.
        </p>
        <p className="mt-3 text-justify text-sm">
          <strong>4.3.1 Cancelamento e vig&ecirc;ncia contratual</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          Ao optar pelo cancelamento, o usu&aacute;rio declara estar ciente de
          que:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Em se tratando de&nbsp;
          <strong>planos mensais</strong>, o pedido de cancelamento ter&aacute;
          efeito&nbsp;
          <strong>a partir do pr&oacute;ximo ciclo de cobran&ccedil;a</strong>,
          permanecendo garantido o acesso completo aos conte&uacute;dos e
          funcionalidades at&eacute; o encerramento do per&iacute;odo mensal
          j&aacute; pago, n&atilde;o sendo devido reembolso do valor
          correspondente ao m&ecirc;s em curso;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Nos&nbsp;
          <strong>planos anuais</strong>, o cancelamento&nbsp;
          <strong>
            antecipado e imotivado n&atilde;o ensejar&aacute; reembolso
            proporcional
          </strong>
          &nbsp;dos valores j&aacute; pagos, salvo se solicitado dentro do prazo
          legal de&nbsp;
          <strong>07 (sete) dias corridos</strong>, contados a partir da data da
          contrata&ccedil;&atilde;o, em conformidade com o&nbsp;
          <strong>artigo 49 do C&oacute;digo de Defesa do Consumidor</strong>,
          que trata do direito de arrependimento nas contrata&ccedil;&otilde;es
          realizadas fora do estabelecimento f&iacute;sico.
        </p>
        <p className="mt-3 text-justify text-sm">
          Ap&oacute;s o decurso desse prazo,&nbsp;
          <strong>
            n&atilde;o haver&aacute; restitui&ccedil;&atilde;o proporcional
          </strong>
          &nbsp;dos valores pagos, salvo em situa&ccedil;&otilde;es excepcionais
          devidamente comprovadas e analisadas individualmente pela GPMED LTDA,
          como falha substancial na presta&ccedil;&atilde;o do servi&ccedil;o,
          indisponibilidade prolongada do acesso ou outras
          situa&ccedil;&otilde;es que possam configurar quebra contratual.
          Nesses casos, a solicita&ccedil;&atilde;o ser&aacute; avaliada com
          base nos princ&iacute;pios da&nbsp;
          <strong>
            razoabilidade, boa-f&eacute; objetiva, equidade e equil&iacute;brio
            contratual
          </strong>
          .
        </p>
        <p className="mt-3 text-justify text-sm">
          <strong>
            4.3.2 Renova&ccedil;&atilde;o autom&aacute;tica da assinatura
          </strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          Todos os planos de assinatura contratados operam sob o regime de&nbsp;
          <strong>renova&ccedil;&atilde;o autom&aacute;tica</strong>, ao final
          de cada ciclo (mensal ou anual),&nbsp;
          <strong>
            mantendo-se as mesmas condi&ccedil;&otilde;es comerciais e
            contratuais previamente acordadas
          </strong>
          , salvo nos casos em que houver:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Altera&ccedil;&atilde;o de valores;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Modifica&ccedil;&otilde;es relevantes nas cl&aacute;usulas
          contratuais;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Substitui&ccedil;&atilde;o do plano por outro equivalente ou superior.
        </p>
        <p className="mt-3 text-justify text-sm">
          Nessas hip&oacute;teses, a GPMED LTDA compromete-se a&nbsp;
          <strong>
            comunicar previamente o usu&aacute;rio com anteced&ecirc;ncia
            m&iacute;nima de 30 (trinta) dias
          </strong>
          , nos termos do&nbsp;
          <strong>
            artigo 6&ordm;, inciso III, do C&oacute;digo de Defesa do Consumidor
          </strong>
          , facultando-lhe o direito de&nbsp;
          <strong>
            cancelar a assinatura sem qualquer &ocirc;nus ou penalidade
          </strong>
          &nbsp;antes da efetiva&ccedil;&atilde;o das altera&ccedil;&otilde;es.
        </p>
        <p className="mt-3 text-justify text-sm">
          A aus&ecirc;ncia de manifesta&ccedil;&atilde;o por parte do
          usu&aacute;rio dentro do referido prazo ser&aacute; interpretada
          como&nbsp;
          <strong>concord&acirc;ncia t&aacute;cita com os novos termos</strong>,
          autorizando-se, assim, a continuidade da cobran&ccedil;a.
        </p>
        <p className="mt-3 text-justify text-sm">
          <strong>4.3.3 Encerramento da assinatura</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          O usu&aacute;rio da&nbsp;
          <strong>Plataforma Digital GPMED </strong>
          poder&aacute;, a qualquer momento, proceder ao&nbsp;
          <strong>encerramento da sua assinatura</strong>, de forma&nbsp;
          <strong>simples, acess&iacute;vel e transparente</strong>, sem a
          imposi&ccedil;&atilde;o de obst&aacute;culos t&eacute;cnicos ou
          pr&aacute;ticas abusivas que dificultem o exerc&iacute;cio desse
          direito, em estrita observ&acirc;ncia ao disposto no&nbsp;
          <strong>
            artigo 6&ordm;, incisos III e IV, e no artigo 39, inciso V, do
            C&oacute;digo de Defesa do Consumidor (CDC)
          </strong>
          .
        </p>
        <p className="mt-3 text-justify text-sm">
          O cancelamento da assinatura poder&aacute; ser realizado por meio de
          dois canais oficiais:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Via aplicativo</strong>: ao acessar o menu&nbsp;
          <strong>&quot;Conta&quot;</strong>
          &nbsp;ou&nbsp;
          <strong>&quot;Assinatura&quot;</strong>, dentro do ambiente
          autenticado da plataforma, o usu&aacute;rio encontrar&aacute; a
          funcionalidade&nbsp;
          <strong>&quot;Cancelar Assinatura&quot;</strong>, que permitir&aacute;
          o encerramento imediato do ciclo de cobran&ccedil;a, com
          confirma&ccedil;&atilde;o em tela e envio autom&aacute;tico de
          notifica&ccedil;&atilde;o para o e-mail cadastrado;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Via atendimento direto</strong>: por meio de
          solicita&ccedil;&atilde;o enviada ao endere&ccedil;o eletr&ocirc;nico
          institucional:&nbsp;
          <strong>cancelamento@oguiadeprescricao.com.br</strong>, contendo os
          dados de identifica&ccedil;&atilde;o do usu&aacute;rio e a
          manifesta&ccedil;&atilde;o expressa de cancelamento da assinatura, o
          qual ser&aacute; processado no prazo m&aacute;ximo de&nbsp;
          <strong>03 (tr&ecirc;s) dias &uacute;teis</strong>, com a devida
          comunica&ccedil;&atilde;o por e-mail ao titular.
        </p>
        <p className="mt-3 text-justify text-sm">
          O pedido de encerramento resultar&aacute; na&nbsp;
          <strong>
            interrup&ccedil;&atilde;o da renova&ccedil;&atilde;o
            autom&aacute;tica
          </strong>
          &nbsp;e na&nbsp;
          <strong>
            manuten&ccedil;&atilde;o do acesso &agrave; plataforma at&eacute; o
            t&eacute;rmino do ciclo contratual vigente
          </strong>
          , respeitando-se integralmente os direitos adquiridos pelo
          usu&aacute;rio, sem que sejam realizadas novas cobran&ccedil;as
          ap&oacute;s o per&iacute;odo j&aacute; pago,&nbsp;
          <strong>
            salvo em caso de pend&ecirc;ncias financeiras anteriores
          </strong>
          , cuja regulariza&ccedil;&atilde;o ser&aacute; previamente comunicada.
        </p>
        <p className="mt-3 text-justify text-sm">
          A GPMED LTDA compromete-se a:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Registrar eletronicamente o pedido de cancelamento, com&nbsp;
          <strong>data, hora, IP e canal utilizado</strong>, garantindo
          rastreabilidade e seguran&ccedil;a jur&iacute;dica;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Preservar, quando necess&aacute;rio, os dados de pagamento e
          transa&ccedil;&otilde;es vinculadas &agrave; assinatura,&nbsp;
          <strong>exclusivamente para fins legais e cont&aacute;beis</strong>,
          respeitando os prazos de reten&ccedil;&atilde;o previstos na
          legisla&ccedil;&atilde;o, conforme os artigos 15 e 16 da&nbsp;
          <strong>
            Lei Geral de Prote&ccedil;&atilde;o de Dados Pessoais (LGPD)
          </strong>
          ;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Encerrar a assinatura do usu&aacute;rio&nbsp;
          <strong>sem qualquer &ocirc;nus adicional</strong>
          &nbsp;ap&oacute;s o ciclo contratado, excetuadas
          situa&ccedil;&otilde;es de inadimplemento contratual, uso indevido da
          plataforma ou dano causado &agrave; empresa ou a terceiros, que
          poder&atilde;o ensejar responsabiliza&ccedil;&atilde;o nos termos
          legais.
        </p>
        <p className="mt-3 text-justify text-sm">
          O encerramento da assinatura&nbsp;
          <strong>
            n&atilde;o implica automaticamente na exclus&atilde;o da conta do
            usu&aacute;rio nem na elimina&ccedil;&atilde;o de seus dados
            pessoais da base da GPMED LTDA
          </strong>
          , os quais continuar&atilde;o armazenados sob as bases legais
          autorizadoras previstas na LGPD, salvo se houver&nbsp;
          <strong>
            solicita&ccedil;&atilde;o expressa e fundamentada para
            exclus&atilde;o definitiva
          </strong>
          , a ser processada de acordo com os crit&eacute;rios legais e
          regulamentares aplic&aacute;veis.
        </p>

        <p className="mt-6 text-justify text-base">
          <strong>5. DIREITOS AUTORAIS E PROPRIEDADE INTELECTUAL</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          Todos os conte&uacute;dos, elementos visuais, funcionais e
          informacionais da plataforma digital GPMED s&atilde;o de titularidade
          exclusiva da&nbsp;
          <strong>GPMED LTDA</strong>, estando protegidos por direitos autorais,
          propriedade industrial e demais normas legais vigentes. &Eacute;&nbsp;
          <strong>
            proibida a reprodu&ccedil;&atilde;o, c&oacute;pia,
            grava&ccedil;&atilde;o, redistribui&ccedil;&atilde;o,
            exibi&ccedil;&atilde;o ou compartilhamento de qualquer material da
            plataforma, ainda que de forma gratuita e sem fins comerciais
          </strong>
          , sem a autoriza&ccedil;&atilde;o expressa, pr&eacute;via e por
          escrito da GPMED LTDA.
        </p>
        <p className="mt-3 text-justify text-sm">
          Esta titularidade abrange, de maneira exemplificativa e n&atilde;o
          exaustiva:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Conte&uacute;dos educacionais</strong>: textos, artigos,
          aulas, v&iacute;deos, podcasts, infogr&aacute;ficos,
          apresenta&ccedil;&otilde;es, materiais interativos e quaisquer
          cria&ccedil;&otilde;es intelectuais desenvolvidas pela equipe da GPMED
          LTDA ou por parceiros contratados mediante cess&atilde;o de
          direitos;&nbsp;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Elementos visuais e gr&aacute;ficos</strong>: imagens,
          logotipos, identidade visual, layout, &iacute;cones e design de
          interface;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Estruturas t&eacute;cnicas e tecnol&oacute;gicas</strong>:
          c&oacute;digo-fonte, bases de dados, APIs, algoritmos, fluxos de
          navega&ccedil;&atilde;o, arquitetura de software e funcionalidades do
          sistema;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Sinais distintivos e marcas</strong>: nomes comerciais,
          dom&iacute;nios, slogans, marcas registradas e demais elementos de
          identifica&ccedil;&atilde;o institucional
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Organiza&ccedil;&atilde;o e estrutura do conte&uacute;do
          </strong>
          , curadoria, estrutura l&oacute;gica e disposi&ccedil;&atilde;o
          pedag&oacute;gica dos materiais, protegidos mesmo sem registro formal,
          nos termos do art. 7&ordm; da Lei de Direitos Autorais (Lei n&ordm;
          9.610/1998).
        </p>
        <p className="mt-3 text-justify text-sm">
          <strong>5.1 Condutas Expressamente Vedadas</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          S&atilde;o proibidas, sem autoriza&ccedil;&atilde;o da GPMED LTDA, as
          seguintes pr&aacute;ticas:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Reprodu&ccedil;&atilde;o, distribui&ccedil;&atilde;o,
          divulga&ccedil;&atilde;o ou exibi&ccedil;&atilde;o p&uacute;blica dos
          conte&uacute;dos protegidos;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Extra&ccedil;&atilde;o de dados e conte&uacute;dos por qualquer meio
          automatizado ou manual (data scraping);
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Pr&aacute;tica de engenharia reversa, descompila&ccedil;&atilde;o ou
          tentativa de acesso ao c&oacute;digo-fonte ou &agrave; l&oacute;gica
          funcional do software;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Modifica&ccedil;&atilde;o, edi&ccedil;&atilde;o,
          tradu&ccedil;&atilde;o, adapta&ccedil;&atilde;o ou
          cria&ccedil;&atilde;o de obras derivadas a partir do conte&uacute;do
          original;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Comercializa&ccedil;&atilde;o, sublicenciamento ou cess&atilde;o de
          acesso n&atilde;o autorizado a terceiros;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Utiliza&ccedil;&atilde;o de elementos visuais ou sinais distintivos da
          marca para qualquer finalidade, inclusive educacional ou n&atilde;o
          lucrativa.
        </p>
        <p className="mt-3 text-justify text-sm">
          A ocorr&ecirc;ncia de qualquer das condutas acima configura&nbsp;
          <strong>viola&ccedil;&atilde;o legal e contratual</strong>, sujeitando
          o infrator &agrave;s san&ccedil;&otilde;es previstas em lei,
          incluindo:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Suspens&atilde;o ou exclus&atilde;o da conta de acesso
          </strong>
          , sem restitui&ccedil;&atilde;o de valores pagos;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Indeniza&ccedil;&atilde;o por perdas e danos materiais e morais
          </strong>
          , nos termos do C&oacute;digo Civil;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Responsabiliza&ccedil;&atilde;o penal</strong>
          &nbsp;conforme o artigo 184 do C&oacute;digo Penal;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Ado&ccedil;&atilde;o de medidas judiciais e extrajudiciais
          </strong>
          &nbsp;para cessa&ccedil;&atilde;o da conduta e repara&ccedil;&atilde;o
          dos danos causados &agrave; GPMED LTDA.
        </p>
        <p className="mt-3 text-justify text-sm">
          <strong>5.2 Multa Contratual por Uso Indevido</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          O uso indevido da Plataforma GPMED, incluindo, mas n&atilde;o se
          limitando ao compartilhamento de login e senha com terceiros,
          reprodu&ccedil;&atilde;o n&atilde;o autorizada de conte&uacute;do,
          pr&aacute;tica de pirataria digital ou qualquer forma de
          viola&ccedil;&atilde;o aos direitos autorais e de propriedade
          intelectual da GPMED LTDA, sujeitar&aacute; o infrator ao pagamento
          de&nbsp;
          <strong>
            multa compensat&oacute;ria no valor correspondente a 10 (dez) vezes
            o valor da assinatura vigente no momento da infra&ccedil;&atilde;o
          </strong>
          , sem preju&iacute;zo da responsabiliza&ccedil;&atilde;o civil, penal
          e da ado&ccedil;&atilde;o de medidas judiciais cab&iacute;veis.
        </p>
        <p className="mt-3 text-justify text-sm">
          <strong>
            5.3 Fundamenta&ccedil;&atilde;o Legal da Prote&ccedil;&atilde;o
          </strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          Todos os elementos descritos s&atilde;o protegidos pelas seguintes
          normas:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Lei de Direitos Autorais (Lei n&ordm; 9.610/1998)</strong>;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Lei da Propriedade Industrial (Lei n&ordm; 9.279/1996)
          </strong>
          ;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Marco Civil da Internet (Lei n&ordm; 12.965/2014)</strong>
          &nbsp;&ndash; especialmente no tocante &agrave;
          preserva&ccedil;&atilde;o de conte&uacute;dos, responsabilidade do
          usu&aacute;rio e guarda de registros;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            C&oacute;digo Civil Brasileiro (arts. 927 e seguintes)
          </strong>
          &nbsp;&ndash; para fins de repara&ccedil;&atilde;o de danos
          patrimoniais e extrapatrimoniais;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>C&oacute;digo Penal (art. 184 e seguintes)</strong>
          &nbsp;&ndash; no que tange &agrave; viola&ccedil;&atilde;o de direito
          autoral como infra&ccedil;&atilde;o penal;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            C&oacute;digo de Defesa do Consumidor (Lei n&ordm; 8.078/1990)
          </strong>
          &nbsp;&ndash; em rela&ccedil;&atilde;o &agrave;
          informa&ccedil;&atilde;o adequada e preven&ccedil;&atilde;o a
          pr&aacute;ticas abusivas no ambiente digital.
        </p>
        <p className="mt-3 text-justify text-sm">
          <strong>5.4 Conte&uacute;do Digital E Licen&ccedil;a De Uso</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          O conte&uacute;do disponibilizado pela GPMED LTDA &eacute; original,
          resultado de esfor&ccedil;o intelectual especializado, abrangendo
          trilhas de aprendizagem, e-books, simulados, mapas mentais,
          infogr&aacute;ficos e demais ativos interativos.
        </p>
        <p className="mt-3 text-justify text-sm">
          A utiliza&ccedil;&atilde;o desses conte&uacute;dos &eacute; concedida
          ao usu&aacute;rio sob&nbsp;
          <strong>
            licen&ccedil;a limitada, pessoal, individual, intransfer&iacute;vel,
            tempor&aacute;ria e revog&aacute;vel
          </strong>
          , exclusivamente para fins educacionais. Esta licen&ccedil;a&nbsp;
          <strong>n&atilde;o implica cess&atilde;o de titularidade</strong>
          &nbsp;e veda:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Reprodu&ccedil;&atilde;o total ou parcial dos conte&uacute;dos;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Redistribui&ccedil;&atilde;o em redes sociais, f&oacute;runs ou
          terceiros ambientes;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Modifica&ccedil;&atilde;o, tradu&ccedil;&atilde;o ou
          adapta&ccedil;&atilde;o;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Monetiza&ccedil;&atilde;o, revenda ou uso comercial de qualquer
          natureza;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Inser&ccedil;&atilde;o em plataformas concorrentes ou cursos
          paralelos.
        </p>
        <p className="mt-3 text-justify text-sm">
          <strong>5.5 SAN&Ccedil;&Otilde;ES PELO USO INDEVIDO</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          A viola&ccedil;&atilde;o das condi&ccedil;&otilde;es de uso
          implicar&aacute; nas seguintes consequ&ecirc;ncias:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Bloqueio imediato do acesso &agrave; conta;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Cancelamento da assinatura, sem reembolso;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          A&ccedil;&otilde;es judiciais por viola&ccedil;&atilde;o de direitos
          autorais (arts. 101 a 110 da Lei n&ordm; 9.610/1998),
          repara&ccedil;&atilde;o de danos (art. 927 do C&oacute;digo Civil) e
          responsabiliza&ccedil;&atilde;o penal (art. 184 do C&oacute;digo
          Penal);
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Monitoramento constante do uso, com logs de navega&ccedil;&atilde;o,
          rastreamento de comportamento e auditoria digital para
          preven&ccedil;&atilde;o de pr&aacute;ticas il&iacute;citas.
        </p>
        <p className="mt-3 text-justify text-sm">
          <strong>5.6 MARCAS, LOGOTIPOS E IDENTIDADE INSTITUCIONAL</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          A marca GPMED LTDA, seu logotipo, slogans, dom&iacute;nios e demais
          elementos de identidade institucional est&atilde;o protegidos
          pela&nbsp;
          <strong>Lei n&ordm; 9.279/1996 (Propriedade Industrial)</strong>,
          sendo ativos exclusivos da empresa. &Eacute; vedado a terceiros o uso,
          imita&ccedil;&atilde;o ou aproveitamento indevido de tais sinais
          distintivos, inclusive nos casos de:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Concorr&ecirc;ncia desleal</strong>
          &nbsp;(art. 195, Lei n&ordm; 9.279/1996);
        </p>

        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Aproveitamento parasit&aacute;rio</strong>
          &nbsp;ou dilui&ccedil;&atilde;o de marca;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Viola&ccedil;&atilde;o de direito marc&aacute;rio</strong>,
          sujeita a medidas civis e criminais.
        </p>
        <p className="mt-3 text-justify text-sm">
          <strong>5.7 MEDIDAS DE PROTE&Ccedil;&Atilde;O E RASTREAMENTO</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          Para proteger seus ativos, a GPMED LTDA adota mecanismos robustos de
          seguran&ccedil;a e controle, tais como:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Login individual e intransfer&iacute;vel;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Registro de logs de acesso e navega&ccedil;&atilde;o;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Monitoramento de tentativas de acesso n&atilde;o autorizado ou
          automatizado (bots);
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Detec&ccedil;&atilde;o de capturas de tela e downloads
          for&ccedil;ados;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Pol&iacute;tica ativa de den&uacute;ncia e resposta a
          infra&ccedil;&otilde;es.
        </p>
        <p className="mt-3 text-justify text-sm">
          A GPMED LTDA poder&aacute; registrar boletins de ocorr&ecirc;ncia,
          instaurar procedimentos administrativos e adotar medidas judiciais em
          defesa de seus direitos, inclusive perante o INPI,
          &oacute;rg&atilde;os reguladores e o Minist&eacute;rio P&uacute;blico.
        </p>

        <p className="mt-6 text-justify text-base">
          <strong>6. LIMITA&Ccedil;&Atilde;O DE RESPONSABILIDADE</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          A&nbsp;
          <strong>Plataforma Digital GPMED </strong>
          desempenha suas atividades com elevado padr&atilde;o de
          dilig&ecirc;ncia t&eacute;cnica, observando rigorosamente os
          princ&iacute;pios da&nbsp;
          <strong>
            boa-f&eacute; objetiva, transpar&ecirc;ncia, lealdade contratual e
            seguran&ccedil;a da informa&ccedil;&atilde;o
          </strong>
          , em conformidade com a legisla&ccedil;&atilde;o brasileira
          aplic&aacute;vel. Compromete-se, assim, a envidar todos os
          esfor&ccedil;os razo&aacute;veis para assegurar a&nbsp;
          <strong>
            estabilidade, integridade, disponibilidade e continuidade dos
            servi&ccedil;os oferecidos
          </strong>
          &nbsp;por meio de sua plataforma, de modo a proporcionar ao
          usu&aacute;rio uma&nbsp;
          <strong>
            experi&ecirc;ncia digital eficiente, segura e confi&aacute;vel
          </strong>
          .
        </p>
        <p className="mt-3 text-justify text-sm">
          Contudo, em raz&atilde;o da&nbsp;
          <strong>
            complexidade intr&iacute;nseca dos sistemas de
            informa&ccedil;&atilde;o
          </strong>
          , da&nbsp;
          <strong>dinamicidade do ambiente digital</strong>
          &nbsp;e da&nbsp;
          <strong>
            interdepend&ecirc;ncia com servi&ccedil;os, dispositivos e
            infraestruturas de terceiros
          </strong>
          &nbsp;&mdash; como provedores de internet, sistemas operacionais,
          servidores externos, meios de pagamento e redes de
          telecomunica&ccedil;&otilde;es &mdash;, a GPMED LTDA estabelece, nos
          termos desta cl&aacute;usula, os&nbsp;
          <strong>limites objetivos de sua responsabilidade civil</strong>,
          conforme autorizam os&nbsp;
          <strong>
            artigos 393, 421, 422 e 927 do C&oacute;digo Civil Brasileiro
          </strong>
          , o&nbsp;
          <strong>artigo 14 do C&oacute;digo de Defesa do Consumidor</strong>
          &nbsp;e os princ&iacute;pios do&nbsp;
          <strong>
            Marco Civil da Internet (Lei n&ordm; 12.965/2014, especialmente art.
            7&ordm;, X e art. 18)
          </strong>
          .
        </p>
        <p className="mt-3 text-justify text-sm">
          A limita&ccedil;&atilde;o de responsabilidade ora prevista visa
          equilibrar a rela&ccedil;&atilde;o contratual,&nbsp;
          <strong>
            protegendo os interesses leg&iacute;timos da empresa sem comprometer
            os direitos fundamentais dos usu&aacute;rios
          </strong>
          , dentro de crit&eacute;rios de&nbsp;
          <strong>
            proporcionalidade, razoabilidade, previsibilidade e causalidade
            direta
          </strong>
          , afastando-se a responsabiliza&ccedil;&atilde;o autom&aacute;tica ou
          gen&eacute;rica por eventos que estejam fora do controle direto da
          GPMED LTDA ou que decorram de&nbsp;
          <strong>
            caso fortuito, for&ccedil;a maior ou conduta exclusiva de terceiros
            ou do pr&oacute;prio usu&aacute;rio
          </strong>
          .
        </p>

        <p className="mt-3 text-justify text-sm">
          <strong>
            6.1 Hip&oacute;teses de Limita&ccedil;&atilde;o de Responsabilidade
          </strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          A&nbsp;
          <strong>Plataforma Digital GPMED </strong>, na condi&ccedil;&atilde;o
          de prestadora de servi&ccedil;os educacionais por meio de plataforma
          digital, declara que&nbsp;
          <strong>
            n&atilde;o poder&aacute; ser responsabilizada civilmente por falhas,
            preju&iacute;zos ou danos de qualquer natureza que n&atilde;o
            decorram de sua a&ccedil;&atilde;o direta, dolosa ou culposa em grau
            grave
          </strong>
          , especialmente nos casos em que tais eventos sejam resultado de
          causas externas, imprevis&iacute;veis ou inevit&aacute;veis, conforme
          preceitua o&nbsp;
          <strong>artigo 393 do C&oacute;digo Civil Brasileiro</strong>,
          al&eacute;m das demais normas aplic&aacute;veis &agrave;
          presta&ccedil;&atilde;o de servi&ccedil;os digitais.
        </p>
        <p className="mt-3 text-justify text-sm">
          Ser&atilde;o consideradas hip&oacute;teses leg&iacute;timas de
          exclus&atilde;o ou limita&ccedil;&atilde;o da responsabilidade, dentre
          outras, as seguintes situa&ccedil;&otilde;es:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Instabilidades t&eacute;cnicas, falhas tempor&aacute;rias de acesso
            ou indisponibilidades moment&acirc;neas da plataforma
          </strong>
          , decorrentes de manuten&ccedil;&atilde;o programada,
          atualiza&ccedil;&otilde;es sist&ecirc;micas, indisponibilidade de
          servi&ccedil;os de telecomunica&ccedil;&atilde;o ou hospedagem de
          terceiros, oscila&ccedil;&otilde;es na rede el&eacute;trica, falhas em
          servidores de data center, ou qualquer outro fator que fuja &agrave;
          gest&atilde;o direta da GPMED LTDA. Nestes casos, a empresa
          compromete-se apenas a&nbsp;
          <strong>
            comunicar tempestivamente o ocorrido e restaurar o servi&ccedil;o no
            menor tempo poss&iacute;vel
          </strong>
          , n&atilde;o sendo devida compensa&ccedil;&atilde;o autom&aacute;tica
          ao usu&aacute;rio, salvo disposi&ccedil;&atilde;o contratual
          espec&iacute;fica;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Ocorr&ecirc;ncia de erros operacionais pontuais (bugs), falhas
            t&eacute;cnicas ou instabilidades ocasionais no sistema
          </strong>
          , desde que n&atilde;o derivadas de omiss&atilde;o reiterada,
          neglig&ecirc;ncia comprovada ou falha estrutural do sistema mantido
          pela GPMED LTDA. Eventuais bugs ou falhas ser&atilde;o tratados
          com&nbsp;
          <strong>
            prioridade t&eacute;cnica compat&iacute;vel com sua criticidade
          </strong>
          , sendo a empresa exonerada de responsabilidade se adotar
          provid&ecirc;ncias diligentes e proporcionais para
          corre&ccedil;&atilde;o e mitiga&ccedil;&atilde;o;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Perda, exclus&atilde;o ou corrup&ccedil;&atilde;o de arquivos, dados
            ou conte&uacute;dos inseridos diretamente pelo usu&aacute;rio
          </strong>
          , causados por fatores relacionados ao seu pr&oacute;prio dispositivo,
          instabilidade do sistema operacional, armazenamento local defeituoso,
          falhas de sincroniza&ccedil;&atilde;o, ataques cibern&eacute;ticos
          sofisticados ou mesmo pela&nbsp;
          <strong>
            remo&ccedil;&atilde;o volunt&aacute;ria ou involunt&aacute;ria da
            Plataforma Digital GPMED{' '}
          </strong>
          por parte do usu&aacute;rio. A responsabilidade pela guarda local dos
          dados inseridos fora do ambiente da GPMED LTDA &eacute; exclusiva do
          titular;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Preju&iacute;zos decorrentes do uso indevido, compartilhamento
            n&atilde;o autorizado ou neglig&ecirc;ncia na prote&ccedil;&atilde;o
            das credenciais de acesso
          </strong>
          &nbsp;(login e senha), inclusive quando utilizados por terceiros
          n&atilde;o autorizados, eximindo-se a GPMED LTDA de qualquer
          responsabilidade por atos praticados por terceiros mediante acesso
          indevido, nos termos dos&nbsp;
          <strong>artigos 186 e 927 do C&oacute;digo Civil</strong>
          &nbsp;e conforme as regras de conduta previstas nesta Pol&iacute;tica
          de Uso.
        </p>
        <p className="mt-3 text-justify text-sm">
          A GPMED LTDA reitera que, nos limites do que disp&otilde;e o&nbsp;
          <strong>
            C&oacute;digo de Defesa do Consumidor (art. 14, &sect;3&ordm;,
            incisos I e II)
          </strong>
          , n&atilde;o responder&aacute; por&nbsp;
          <strong>
            eventuais v&iacute;cios ou falhas na presta&ccedil;&atilde;o do
            servi&ccedil;o
          </strong>
          &nbsp;quando comprovada a&nbsp;
          <strong>inexist&ecirc;ncia de defeito</strong>, o&nbsp;
          <strong>uso inadequado pelo consumidor</strong>
          &nbsp;ou a&nbsp;
          <strong>culpa exclusiva de terceiro</strong>, ressalvadas as
          situa&ccedil;&otilde;es excepcionais que envolvam dolo ou
          omiss&atilde;o grave por parte da empresa.
        </p>
        <p className="mt-3 text-justify text-sm">
          <strong>
            6.2 Exclus&atilde;o de Responsabilidade por Atos de Terceiros
          </strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          A&nbsp;
          <strong>Plataforma Digital GPMED,</strong>
          &nbsp;nos termos do&nbsp;
          <strong>
            artigo 14, &sect;3&ordm;, do C&oacute;digo de Defesa do Consumidor
          </strong>
          , e do&nbsp;
          <strong>
            artigo 18 do Marco Civil da Internet (Lei n&ordm; 12.965/2014)
          </strong>
          ,&nbsp;
          <strong>
            n&atilde;o poder&aacute; ser responsabilizada por danos,
            preju&iacute;zos, falhas ou interrup&ccedil;&otilde;es decorrentes
            de atos, omiss&otilde;es ou condutas de terceiros
          </strong>
          , alheios &agrave; sua atua&ccedil;&atilde;o direta, cujos efeitos
          impactem, ainda que indiretamente, a experi&ecirc;ncia do
          usu&aacute;rio ou a integridade dos dados tratados pela plataforma.
        </p>
        <p className="mt-3 text-justify text-sm">
          Essa exclus&atilde;o de responsabilidade abrange, mas n&atilde;o se
          limita &agrave;s seguintes situa&ccedil;&otilde;es:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Atos ou falhas de intermediadores financeiros e servi&ccedil;os de
            pagamento eletr&ocirc;nico
          </strong>
          , utilizados para viabilizar a contrata&ccedil;&atilde;o de planos de
          assinatura, como operadoras de cart&atilde;o de cr&eacute;dito,
          gateways de pagamento, institui&ccedil;&otilde;es banc&aacute;rias ou
          plataformas de cobran&ccedil;a recorrente. A GPMED LTDA atua como
          tomadora de servi&ccedil;os e n&atilde;o exerce controle sobre a
          execu&ccedil;&atilde;o operacional dessas transa&ccedil;&otilde;es.
          Qualquer indisponibilidade, atraso, estorno ou falha na
          aprova&ccedil;&atilde;o de pagamentos dever&aacute; ser tratada
          diretamente entre o usu&aacute;rio e a institui&ccedil;&atilde;o
          respons&aacute;vel, conforme os termos e pol&iacute;ticas dessas
          empresas;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Plataformas externas utilizadas para autentica&ccedil;&atilde;o de
            acesso
          </strong>
          , como Google, Apple, Facebook ou outros provedores de login social,
          quando eventualmente integradas &agrave; solu&ccedil;&atilde;o
          tecnol&oacute;gica da GPMED LTDA. O funcionamento, a seguran&ccedil;a
          e a disponibilidade desses servi&ccedil;os s&atilde;o de
          responsabilidade exclusiva das respectivas empresas, n&atilde;o
          respondendo a GPMED LTDA por falhas de integra&ccedil;&atilde;o,
          quedas de servi&ccedil;o, desvios de dados ou revoga&ccedil;&atilde;o
          de permiss&otilde;es por parte do usu&aacute;rio;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Conte&uacute;dos inseridos, publicados, compartilhados ou
            transmitidos por usu&aacute;rios em &aacute;reas abertas de
            comunica&ccedil;&atilde;o
          </strong>
          , tais como f&oacute;runs, espa&ccedil;os de coment&aacute;rios,
          enquetes, chats ou recursos interativos disponibilizados pela
          plataforma, caso existam. A GPMED LTDA&nbsp;
          <strong>
            n&atilde;o endossa, revisa previamente ou assume responsabilidade
            por opini&otilde;es, informa&ccedil;&otilde;es ou
            manifesta&ccedil;&otilde;es individuais publicadas por terceiros
          </strong>
          , ficando o autor exclusivamente respons&aacute;vel civil e
          criminalmente pelo que publicar, nos termos do artigo 19 do Marco
          Civil da Internet;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Links ou redirecionamentos para sites externos ou de terceiros
          </strong>
          , eventualmente inseridos como refer&ecirc;ncia ou complemento de
          conte&uacute;do, cuja integridade, veracidade e seguran&ccedil;a
          n&atilde;o podem ser auditadas pela GPMED LTDA. O acesso a tais
          ambientes ser&aacute; feito por conta e risco do usu&aacute;rio.
        </p>
        <p className="mt-3 text-justify text-sm">
          A GPMED LTDA se compromete, no entanto, a&nbsp;
          <strong>adotar medidas diligentes e proporcionais</strong>
          &nbsp;para corrigir, notificar ou desabilitar
          integra&ccedil;&otilde;es que possam, comprovadamente, afetar
          negativamente os direitos dos usu&aacute;rios ou comprometer a
          seguran&ccedil;a da plataforma, desde que tenha conhecimento formal,
          inequ&iacute;voco e motivado de tais ocorr&ecirc;ncias.
        </p>
        <p className="mt-3 text-justify text-sm">
          <strong>
            6.3 Exce&ccedil;&atilde;o em Caso de Dolo ou Culpa Grave
          </strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          As cl&aacute;usulas de limita&ccedil;&atilde;o de responsabilidade
          previstas nesta Pol&iacute;tica&nbsp;
          <strong>
            n&atilde;o se aplicam &agrave;s hip&oacute;teses em que restar
            comprovada a exist&ecirc;ncia de dolo, culpa grave,
            m&aacute;-f&eacute;, fraude ou conduta intencionalmente lesiva por
            parte da Plataforma Digital GPMED ou de seus prepostos
          </strong>
          , nos termos do&nbsp;
          <strong>
            artigo 186 e artigo 927 do C&oacute;digo Civil Brasileiro
          </strong>
          , bem como dos&nbsp;
          <strong>
            artigos 6&ordm;, 14 e 20 do C&oacute;digo de Defesa do Consumidor
            (CDC &ndash; Lei n&ordm; 8.078/1990)
          </strong>
          .
        </p>
        <p className="mt-3 text-justify text-sm">
          Nessas circunst&acirc;ncias excepcionais, em que fique demonstrado que
          o dano suportado pelo usu&aacute;rio foi causado diretamente por&nbsp;
          <strong>
            conduta dolosa, fraudulenta ou gravemente negligente da empresa
          </strong>
          , ser&aacute; assegurado ao titular o&nbsp;
          <strong>
            direito &agrave; repara&ccedil;&atilde;o integral dos
            preju&iacute;zos materiais, extrapatrimoniais e morais sofridos
          </strong>
          , incluindo lucros cessantes e danos emergentes, observando-se os
          princ&iacute;pios da&nbsp;
          <strong>
            repara&ccedil;&atilde;o integral, boa-f&eacute; objetiva e dever de
            indenizar
          </strong>
          &nbsp;consagrados no ordenamento jur&iacute;dico.
        </p>
        <p className="mt-3 text-justify text-sm">
          A responsabiliza&ccedil;&atilde;o da GPMED LTDA seguir&aacute;
          crit&eacute;rios t&eacute;cnicos e jur&iacute;dicos compat&iacute;veis
          com a&nbsp;
          <strong>
            natureza do servi&ccedil;o prestado, o nexo de causalidade entre a
            conduta e o dano
          </strong>
          , a&nbsp;
          <strong>
            exist&ecirc;ncia de prova inequ&iacute;voca do il&iacute;cito e da
            extens&atilde;o do preju&iacute;zo
          </strong>
          , sendo vedada:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>A atribui&ccedil;&atilde;o de responsabilidade de forma
          presumida ou gen&eacute;rica;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>A responsabiliza&ccedil;&atilde;o objetiva por fatos
          atribu&iacute;veis exclusivamente a terceiros ou ao pr&oacute;prio
          usu&aacute;rio;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>A condena&ccedil;&atilde;o por&nbsp;
          <strong>
            danos hipot&eacute;ticos, meramente especulativos ou n&atilde;o
            demonstrados com base em elementos concretos
          </strong>
          .
        </p>
        <p className="mt-3 text-justify text-sm">
          O usu&aacute;rio reconhece que o dever de indenizar depende da&nbsp;
          <strong>
            comprova&ccedil;&atilde;o inequ&iacute;voca da conduta
            il&iacute;cita, do dano efetivo e do nexo causal direto
          </strong>
          , conforme preconizado pelo sistema de responsabilidade civil
          brasileiro.
        </p>

        <p className="mt-6 text-justify text-base">
          <strong>7. CANCELAMENTO, SUSPENS&Atilde;O E EXCLUS&Atilde;O</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          A&nbsp;
          <strong>Plataforma Digital GPMED,</strong>
          &nbsp;no exerc&iacute;cio de suas atividades e no fornecimento de
          servi&ccedil;os educacionais por meio digital,&nbsp;
          <strong>
            reconhece e respeita os princ&iacute;pios fundamentais da
            boa-f&eacute; objetiva, da fun&ccedil;&atilde;o social do contrato,
            da transpar&ecirc;ncia, do equil&iacute;brio nas
            rela&ccedil;&otilde;es jur&iacute;dicas e da seguran&ccedil;a
            jur&iacute;dica
          </strong>
          , conforme previsto no&nbsp;
          <strong>C&oacute;digo Civil Brasileiro (arts. 113, 421 e 422)</strong>
          , bem como nas legisla&ccedil;&otilde;es espec&iacute;ficas que
          regulam os servi&ccedil;os digitais e a prote&ccedil;&atilde;o de
          dados pessoais.
        </p>
        <p className="mt-3 text-justify text-sm">
          Nesta se&ccedil;&atilde;o, a GPMED LTDA define de forma clara,
          objetiva e conforme os preceitos normativos aplic&aacute;veis,
          as&nbsp;
          <strong>
            condi&ccedil;&otilde;es para o cancelamento volunt&aacute;rio da
            conta pelo usu&aacute;rio
          </strong>
          , bem como os&nbsp;
          <strong>
            cen&aacute;rios em que poder&aacute; exercer seu direito de
            suspender, restringir ou cancelar unilateralmente o acesso de
            determinados perfis
          </strong>
          , especialmente nos casos de infra&ccedil;&atilde;o legal, contratual
          ou de risco &agrave; integridade da plataforma.
        </p>
        <p className="mt-3 text-justify text-sm">
          Al&eacute;m disso, s&atilde;o tamb&eacute;m estabelecidos os&nbsp;
          <strong>
            crit&eacute;rios legais e t&eacute;cnicos para o tratamento,
            reten&ccedil;&atilde;o, anonimiza&ccedil;&atilde;o e exclus&atilde;o
            dos dados pessoais
          </strong>
          &nbsp;ap&oacute;s o encerramento da conta, em estrita conformidade com
          os&nbsp;
          <strong>
            artigos 15 e 16 da Lei Geral de Prote&ccedil;&atilde;o de Dados
            Pessoais (LGPD &ndash; Lei n&ordm; 13.709/2018)
          </strong>
          , com os&nbsp;
          <strong>
            artigos 7&ordm;, 18 e 19 do Marco Civil da Internet (Lei n&ordm;
            12.965/2014)
          </strong>
          , e com os&nbsp;
          <strong>
            artigos 6&ordm; e 20 do C&oacute;digo de Defesa do Consumidor (Lei
            n&ordm; 8.078/1990)
          </strong>
          .
        </p>
        <p className="mt-3 text-justify text-sm">
          Todas as medidas descritas s&atilde;o orientadas pelo compromisso
          institucional da GPMED LTDA com o respeito &agrave;
          autodetermina&ccedil;&atilde;o informativa, &agrave; liberdade
          contratual com responsabilidade, ao direito &agrave;
          informa&ccedil;&atilde;o clara e ao adequado exerc&iacute;cio dos
          direitos dos titulares de dados, refor&ccedil;ando sua pol&iacute;tica
          de conformidade e &eacute;tica digital.
        </p>

        <p className="mt-3 text-justify text-sm">
          <strong>
            7.1 Cancelamento da conta por iniciativa do usu&aacute;rio
          </strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          O usu&aacute;rio poder&aacute;, a qualquer momento, solicitar o&nbsp;
          <strong>cancelamento definitivo de sua conta de acesso</strong>,
          mediante:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Requisi&ccedil;&atilde;o expressa por meio da &aacute;rea
          &quot;Conta&quot; ou &quot;Assinatura&quot; dentro do Plataforma
          Digital GPMED;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Solicita&ccedil;&atilde;o direta ao canal oficial de
          atendimento:&nbsp;
          <a href="mailto:cancelamento@oguiadeprescricao.com.br">
            cancelamento@oguiadeprescricao.com.br
          </a>
          .&nbsp;
        </p>
        <p className="mt-3 text-justify text-sm">
          O cancelamento de assinatura n&atilde;o implica, automaticamente, na
          exclus&atilde;o de todos os dados pessoais armazenados, sendo
          necess&aacute;rio, caso deseje, o envio de&nbsp;
          <strong>pedido espec&iacute;fico de exclus&atilde;o de dados</strong>,
          nos termos do&nbsp;
          <strong>artigo 18, inciso VI da LGPD</strong>.
        </p>
        <p className="mt-3 text-justify text-sm">
          Durante o processo de cancelamento, a GPMED LTDA poder&aacute; adotar
          medidas de&nbsp;
          <strong>valida&ccedil;&atilde;o de identidade do solicitante</strong>
          &nbsp;para garantir a seguran&ccedil;a e evitar exclus&atilde;o
          indevida por terceiros.
        </p>
        <p className="mt-3 text-justify text-sm">
          <strong>
            7.2 Suspens&atilde;o ou cancelamento por iniciativa da GPMED LTDA
          </strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          A GPMED LTDA poder&aacute;&nbsp;
          <strong>
            suspender temporariamente, limitar o acesso ou excluir
            definitivamente contas de usu&aacute;rios
          </strong>
          &nbsp;nas seguintes hip&oacute;teses, sem preju&iacute;zo de outras
          medidas legais cab&iacute;veis:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Viola&ccedil;&atilde;o dos Termos de Uso, Pol&iacute;tica de
            Privacidade ou Regras de Conduta
          </strong>
          ;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Apresenta&ccedil;&atilde;o de informa&ccedil;&otilde;es cadastrais
            falsas, incompletas, fraudulentas ou enganosas
          </strong>
          ;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Identifica&ccedil;&atilde;o de comportamento suspeito, tentativa de
            fraude, viola&ccedil;&atilde;o de seguran&ccedil;a ou pr&aacute;tica
            de pirataria
          </strong>
          ;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Utiliza&ccedil;&atilde;o indevida da plataforma, incluindo fins
            il&iacute;citos, comerciais n&atilde;o autorizados ou ofensivos a
            terceiros
          </strong>
          ;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Inatividade da conta por per&iacute;odo superior a 12 (doze) meses
          </strong>
          ;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Decis&atilde;o judicial ou requisi&ccedil;&atilde;o formal de
            autoridade competente
          </strong>
          ;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Incumprimento contratual ou inadimplemento reiterado em
            rela&ccedil;&atilde;o aos planos de assinatura
          </strong>
          .
        </p>
        <p className="mt-3 text-justify text-sm">
          Antes da exclus&atilde;o definitiva, sempre que poss&iacute;vel, o
          usu&aacute;rio ser&aacute; notificado por e-mail ou
          notifica&ccedil;&atilde;o interna do Plataforma Digital GPMED, podendo
          apresentar justificativa ou contesta&ccedil;&atilde;o em
          at&eacute;&nbsp;
          <strong>5 (cinco) dias &uacute;teis</strong>, salvo nos casos de risco
          iminente &agrave; seguran&ccedil;a da plataforma ou de terceiros.
        </p>

        <p className="mt-3 text-justify text-sm">
          <strong>
            7.3 Tratamento e exclus&atilde;o de dados pessoais ap&oacute;s
            encerramento da conta
          </strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          Ap&oacute;s o encerramento da conta, a GPMED LTDA manter&aacute; os
          dados pessoais do titular&nbsp;
          <strong>
            somente pelo prazo necess&aacute;rio para cumprimento de
            obriga&ccedil;&otilde;es legais, regulat&oacute;rias, contratuais ou
            para exerc&iacute;cio regular de direitos em processos judiciais,
            administrativos ou arbitrais
          </strong>
          , conforme previsto nos&nbsp;
          <strong>artigos 15 e 16 da LGPD</strong>.
        </p>
        <p className="mt-3 text-justify text-sm">
          Encerradas essas finalidades, os dados:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Ser&atilde;o&nbsp;
          <strong>eliminados de forma segura e definitiva</strong>, ou;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Anonimizados</strong>, de forma que n&atilde;o possam mais ser
          associados ao titular, para fins estat&iacute;sticos,
          anal&iacute;ticos ou de melhoria de servi&ccedil;os, conforme
          permissivo legal do artigo 12, &sect;1&ordm; da LGPD.
        </p>
        <p className="mt-3 text-justify text-sm">
          A GPMED LTDA assegura ao titular o direito de&nbsp;
          <strong>solicitar a exclus&atilde;o dos dados remanescentes</strong>,
          salvo nas hip&oacute;teses legais de conserva&ccedil;&atilde;o
          obrigat&oacute;ria, mediante envio de solicita&ccedil;&atilde;o formal
          ao Encarregado de Prote&ccedil;&atilde;o de Dados (DPO) pelo
          e-mail:&nbsp;
          <a href="mailto:dpo@oguiadeprescricao.com.br">
            dpo@oguiadeprescricao.com.br
          </a>
          .
        </p>
        <p className="mt-6 text-justify text-base">
          <strong>
            8. INDISPONIBILIDADE PROGRAMADA E COMUNICA&Ccedil;&Atilde;O DE
            MANUTEN&Ccedil;&Atilde;O DOS SERVI&Ccedil;OS
          </strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          A CONTRATADA poder&aacute; realizar, de forma peri&oacute;dica ou
          emergencial, manuten&ccedil;&otilde;es t&eacute;cnicas, preventivas,
          corretivas ou evolutivas em seus sistemas, servidores, aplicativos ou
          demais estruturas tecnol&oacute;gicas, visando assegurar a
          estabilidade, a seguran&ccedil;a, a continuidade e a melhoria dos
          servi&ccedil;os prestados.
        </p>
        <p className="mt-3 text-justify text-sm">
          As manuten&ccedil;&otilde;es programadas poder&atilde;o implicar
          na&nbsp;
          <strong>
            indisponibilidade tempor&aacute;ria dos servi&ccedil;os
          </strong>
          , respeitado o limite de&nbsp;
          <strong>
            at&eacute; 5% (cinco por cento) do tempo de atividade anual
          </strong>
          , considerado razo&aacute;vel e proporcional, conforme os
          padr&otilde;es t&eacute;cnicos do setor e as boas pr&aacute;ticas
          previstas na legisla&ccedil;&atilde;o aplic&aacute;vel, incluindo, mas
          n&atilde;o se limitando, &agrave; Lei n&ordm; 13.709/2018 (LGPD),
          &agrave; Lei n&ordm; 12.965/2014 (Marco Civil da Internet), ao
          C&oacute;digo de Defesa do Consumidor (Lei n&ordm; 8.078/1990) e ao
          C&oacute;digo Civil.
        </p>
        <p className="mt-3 text-justify text-sm">
          Sempre que houver necessidade de manuten&ccedil;&atilde;o programada
          que possa causar indisponibilidade dos servi&ccedil;os, a CONTRATADA
          compromete-se a&nbsp;
          <strong>comunicar previamente os usu&aacute;rios</strong>, com
          anteced&ecirc;ncia razo&aacute;vel, por meio dos canais oficiais,
          informando:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>A natureza da manuten&ccedil;&atilde;o;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>A data e hora previstas para in&iacute;cio e
          t&eacute;rmino da indisponibilidade;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          As funcionalidades que poder&atilde;o ser afetadas; e
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>A previs&atilde;o de retorno &agrave; normalidade.
        </p>
        <p className="mt-3 text-justify text-sm">
          Nos casos de&nbsp;
          <strong>
            manuten&ccedil;&atilde;o emergencial ou falhas t&eacute;cnicas
            imprevis&iacute;veis
          </strong>
          , a CONTRATADA envidar&aacute; os melhores esfor&ccedil;os para
          restabelecer os servi&ccedil;os no menor tempo poss&iacute;vel, bem
          como&nbsp;
          <strong>
            informar aos usu&aacute;rios, com a maior brevidade razo&aacute;vel
          </strong>
          , sobre a indisponibilidade, as medidas corretivas em curso e a
          estimativa de normaliza&ccedil;&atilde;o.
        </p>
        <p className="mt-3 text-justify text-sm">
          A CONTRATADA&nbsp;
          <strong>
            n&atilde;o ser&aacute; responsabilizada por eventuais perdas ou
            danos indiretos decorrentes de indisponibilidades tempor&aacute;rias
            dos servi&ccedil;os
          </strong>
          , desde que respeitados os limites previstos nesta cl&aacute;usula e
          observadas as obriga&ccedil;&otilde;es de transpar&ecirc;ncia,
          boa-f&eacute; objetiva, seguran&ccedil;a e informa&ccedil;&atilde;o,
          nos termos do art. 6&ordm; da LGPD, dos arts. 4&ordm; e 7&ordm; do
          Marco Civil da Internet e das normas aplic&aacute;veis do
          C&oacute;digo de Defesa do Consumidor e do C&oacute;digo Civil.
        </p>
        <p className="mt-3 text-justify text-sm">
          A aceita&ccedil;&atilde;o desta cl&aacute;usula pelo USU&Aacute;RIO
          implica ci&ecirc;ncia e concord&acirc;ncia quanto &agrave;
          possibilidade de interrup&ccedil;&otilde;es tempor&aacute;rias, desde
          que notificadas nos termos aqui previstos, sem que isso configure
          falha na presta&ccedil;&atilde;o do servi&ccedil;o ou descumprimento
          contratual.
        </p>
        <p className="mt-3 text-justify text-sm">
          <strong>
            8.1 Manuten&ccedil;&otilde;es N&atilde;o Programadas,
            Restabelecimento de Servi&ccedil;os e Garantias M&iacute;nimas
          </strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          A CONTRATADA informa que, em situa&ccedil;&otilde;es
          extraordin&aacute;rias, poder&atilde;o ocorrer&nbsp;
          <strong>manuten&ccedil;&otilde;es n&atilde;o programadas</strong>,
          interrup&ccedil;&otilde;es t&eacute;cnicas, falhas sist&ecirc;micas,
          oscila&ccedil;&otilde;es nos servidores ou outros eventos imprevistos
          que afetem parcial ou totalmente a disponibilidade dos servi&ccedil;os
          prestados.
        </p>
        <p className="mt-3 text-justify text-sm">
          Nessas hip&oacute;teses,&nbsp;
          <strong>
            n&atilde;o haver&aacute; notifica&ccedil;&atilde;o pr&eacute;via aos
            usu&aacute;rios
          </strong>
          , dada a natureza emergencial da ocorr&ecirc;ncia. No entanto, a
          CONTRATADA&nbsp;
          <strong>
            se compromete a adotar todas as medidas t&eacute;cnicas e
            organizacionais cab&iacute;veis para restabelecer a plena
            funcionalidade dos servi&ccedil;os com a m&aacute;xima celeridade e
            efic&aacute;cia poss&iacute;vel
          </strong>
          , priorizando a&nbsp;
          <strong>
            continuidade, a seguran&ccedil;a da informa&ccedil;&atilde;o, a
            integridade dos dados pessoais
          </strong>
          &nbsp;e a&nbsp;
          <strong>usabilidade da plataforma</strong>.
        </p>
        <p className="mt-3 text-justify text-sm">
          Durante esse per&iacute;odo, a CONTRATADA poder&aacute; limitar total
          ou parcialmente determinadas funcionalidades, sempre com o objetivo
          de&nbsp;
          <strong>
            proteger a integridade dos dados, a confidencialidade das
            informa&ccedil;&otilde;es e a estabilidade dos sistemas
          </strong>
          , em conformidade com os princ&iacute;pios da&nbsp;
          <strong>boa-f&eacute;</strong>, da&nbsp;
          <strong>transpar&ecirc;ncia</strong>, da&nbsp;
          <strong>responsabilidade</strong>, da&nbsp;
          <strong>preven&ccedil;&atilde;o</strong>
          &nbsp;e da&nbsp;
          <strong>seguran&ccedil;a</strong>, conforme disposto na&nbsp;
          <strong>Lei n&ordm; 13.709/2018 (LGPD)</strong>
          &nbsp;e na&nbsp;
          <strong>Lei n&ordm; 12.965/2014 (Marco Civil da Internet)</strong>.
        </p>
        <p className="mt-3 text-justify text-sm">
          Conclu&iacute;do o processo de estabiliza&ccedil;&atilde;o e retorno
          dos servi&ccedil;os, a CONTRATADA&nbsp;
          <strong>
            informar&aacute; aos usu&aacute;rios, por meio de seus canais
            oficiais de comunica&ccedil;&atilde;o
          </strong>
          , sobre:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>O restabelecimento do servi&ccedil;o;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          As causas do evento ou incidente;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          As provid&ecirc;ncias adotadas para a corre&ccedil;&atilde;o e
          preven&ccedil;&atilde;o de recorr&ecirc;ncia.
        </p>
        <p className="mt-3 text-justify text-sm">
          A aus&ecirc;ncia de aviso pr&eacute;vio em tais casos n&atilde;o
          configura omiss&atilde;o, neglig&ecirc;ncia ou falha contratual, desde
          que haja posterior comunica&ccedil;&atilde;o adequada e respeito
          &agrave;s normas vigentes, inclusive &agrave;s
          disposi&ccedil;&otilde;es do&nbsp;
          <strong>C&oacute;digo de Defesa do Consumidor</strong>
          &nbsp;e do&nbsp;
          <strong>C&oacute;digo Civil Brasileiro</strong>, no que couber.
        </p>
        <p className="mt-3 text-justify text-sm">
          Esta cl&aacute;usula visa garantir equil&iacute;brio entre a
          expectativa leg&iacute;tima de continuidade dos servi&ccedil;os e a
          necessidade t&eacute;cnica de garantir a&nbsp;
          <strong>
            seguran&ccedil;a, estabilidade e prote&ccedil;&atilde;o dos dados e
            da plataforma
          </strong>
          , em conformidade com a legisla&ccedil;&atilde;o aplic&aacute;vel.
        </p>
        <p className="mt-6 text-justify text-base">
          <strong>
            9. DAS ALTERA&Ccedil;&Otilde;ES NOS TERMOS DE USO E POL&Iacute;TICA
            DE PRIVACIDADE
          </strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          A&nbsp;
          <strong>Plataforma Digital GPMED </strong>
          reserva-se o direito de, a qualquer tempo, atualizar ou modificar este
          Termo de Uso, a Pol&iacute;tica de Privacidade e os demais documentos
          que regem a utiliza&ccedil;&atilde;o de seus servi&ccedil;os, com
          vistas &agrave; sua adequa&ccedil;&atilde;o normativa, t&eacute;cnica
          e operacional, conforme evolu&ccedil;&atilde;o da
          legisla&ccedil;&atilde;o, orienta&ccedil;&otilde;es da ANPD e das boas
          pr&aacute;ticas de governan&ccedil;a.
        </p>
        <p className="mt-3 text-justify text-sm">
          As altera&ccedil;&otilde;es ser&atilde;o publicadas no ambiente da
          plataforma, com destaque apropriado, e, quando substanciais,
          notificadas previamente aos usu&aacute;rios por meio de canais
          oficiais. O uso continuado da plataforma ap&oacute;s a entrada em
          vigor das altera&ccedil;&otilde;es ser&aacute; interpretado como
          concord&acirc;ncia t&aacute;cita com os novos termos e
          condi&ccedil;&otilde;es.
        </p>
        <p className="mt-3 text-justify text-sm">
          Caso o usu&aacute;rio n&atilde;o concorde com as
          altera&ccedil;&otilde;es promovidas, dever&aacute; manifestar-se
          expressamente no prazo de at&eacute;&nbsp;
          <strong>30 (trinta) dias</strong>
          &nbsp;contados da data de disponibiliza&ccedil;&atilde;o da nova
          vers&atilde;o, atrav&eacute;s do canal de atendimento oficial da
          plataforma, no endere&ccedil;o eletr&ocirc;nico:&nbsp;
          <a href="mailto:contato@oguiadeprescricao.com.br">
            contato@oguiadeprescricao.com.br
          </a>
          .&nbsp;
        </p>
        <p className="mt-3 text-justify text-sm">
          Nessa hip&oacute;tese, o usu&aacute;rio poder&aacute; optar pela
          descontinua&ccedil;&atilde;o dos servi&ccedil;os, sem preju&iacute;zo
          &agrave; continuidade do tratamento dos dados pessoais que seja
          necess&aacute;rio para cumprimento de obriga&ccedil;&otilde;es legais
          ou regulat&oacute;rias, exerc&iacute;cio regular de direitos, ou nas
          demais hip&oacute;teses previstas nos artigos 7&ordm; e 11 da Lei
          n&ordm; 13.709/2018 &ndash; Lei Geral de Prote&ccedil;&atilde;o de
          Dados Pessoais (LGPD). A n&atilde;o manifesta&ccedil;&atilde;o no
          prazo estipulado ser&aacute; interpretada como aceite das
          altera&ccedil;&otilde;es.
        </p>
        <p className="mt-6 text-justify text-base">
          <strong>
            10. DA LEGISLA&Ccedil;&Atilde;O APLICADA SUBSIDIARIAMENTE
          </strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          Os presentes Termos de Uso regem-se pelas leis da Rep&uacute;blica
          Federativa do Brasil. Usu&aacute;rios localizados fora do
          territ&oacute;rio nacional reconhecem a&nbsp;
          <strong>
            jurisdi&ccedil;&atilde;o exclusiva das leis brasileiras
          </strong>
          &nbsp;e do foro eleito neste instrumento, sendo expressamente vedado o
          uso da plataforma em pa&iacute;ses cujas legisla&ccedil;&otilde;es
          conflitem com os princ&iacute;pios e finalidades da GPMED LTDA.
        </p>
        <p className="mt-3 text-justify text-sm">
          Na aus&ecirc;ncia de disposi&ccedil;&otilde;es espec&iacute;ficas
          neste instrumento, aplica-se de forma subsidi&aacute;ria e
          complementar a legisla&ccedil;&atilde;o brasileira vigente,
          especialmente:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          O&nbsp;
          <strong>C&oacute;digo Civil Brasileiro</strong>, para reger
          obriga&ccedil;&otilde;es, responsabilidade e
          interpreta&ccedil;&atilde;o contratual;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>O
          <strong> C&oacute;digo de Defesa do Consumidor</strong>, no que couber
          &agrave;s rela&ccedil;&otilde;es de consumo digital;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          A&nbsp;
          <strong>LGPD</strong>, como marco normativo da prote&ccedil;&atilde;o
          de dados pessoais;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          O&nbsp;
          <strong>Marco Civil da Internet</strong>, como regramento fundamental
          das rela&ccedil;&otilde;es em ambiente digital;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          O&nbsp;
          <strong>C&oacute;digo Penal</strong>, para
          responsabiliza&ccedil;&atilde;o em casos de infra&ccedil;&otilde;es
          penais contra a plataforma, seus dados ou demais usu&aacute;rios.
        </p>
        <p className="mt-3 text-justify text-sm">
          As presentes disposi&ccedil;&otilde;es refletem o compromisso
          institucional da GPMED LTDA com a&nbsp;
          <strong>
            &eacute;tica, legalidade, inova&ccedil;&atilde;o respons&aacute;vel
            e prote&ccedil;&atilde;o do usu&aacute;rio no ambiente digital
            brasileiro
          </strong>
          .
        </p>
        <p className="mt-6 text-justify text-base">
          <strong>
            11. MEDIA&Ccedil;&Atilde;O PR&Eacute;VIA E FORO DE
            ELEI&Ccedil;&Atilde;O
          </strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          Antes do ajuizamento de qualquer a&ccedil;&atilde;o judicial
          relacionada aos presentes Termos de Uso, as partes comprometem-se a
          submeter a controv&eacute;rsia &agrave;&nbsp;
          <strong>tentativa de media&ccedil;&atilde;o extrajudicial</strong>, a
          ser realizada por meio digital, junto a c&acirc;mara de
          media&ccedil;&atilde;o privada ou por ferramenta eletr&ocirc;nica da
          pr&oacute;pria Plataforma, no prazo de at&eacute; 15 (quinze) dias
          &uacute;teis a contar da notifica&ccedil;&atilde;o da parte
          interessada.
        </p>
        <p className="mt-3 text-justify text-sm">
          Esgotada a via conciliat&oacute;ria, elegem as partes o foro da
          Comarca de&nbsp;
          <strong>S&atilde;o Jos&eacute; do Rio Preto/SP</strong>, com
          ren&uacute;ncia a qualquer outro, por mais privilegiado que seja.
        </p>
      </div>
    </main>
  );
}

export default Terms;
